ticket = {
    /**
     *
     * Funkcia na generovanie tiketu
     *
     * @param data          List oddov ktore sa budu renderovat (Odds, OddsCombi, Combi)
     * @param oddID         Renderuje len dany odd
     * @param rebuild       Vyrenderuje cely tiket nanovo
     * @param ticketWS      Data prisli zo sluzby - ticketWS
     * @param hasOdd        Specialny parameter
     */
    ticket: function(data, oddID, rebuild, ticketWS, hasOdd) {
        try {
            if (data) {
                if ((profile.ConsoleLog || profile.ConsoleLog$.Ticket) && ticketWS) console.log(data);

                // Fix permanentne stlacenych tlacidiel
                $("#footer-sidebar .combi-options .ui-btn-down-a").removeClass("ui-btn-down-a");

                // Nastavi MinDeposit
                if (!data.HasVirtualGame) {
                    stored.MinDeposit = profile.MinDep;
                } else {
                    stored.MinDeposit = profile.MinDepVG;
                }

                // Nastavi dlzku oneskorenia pri editacii tiketu
                if (data && data.IsEdited && ticketWS) {
                    ticket.state.setState({liveBetDelayMs: data.LiveBetDelayMs});
                }

                // Vymaze tiket a listy (rebuild)
                if (rebuild) {
                    list.Odds = [];
                    list.Events = [];
                    list.Sync = list.Count = 0;
                    if (data.Odds) list.Count = data.Odds.length;
                    $(".ticket-header__item--tips .ticket-header__value").text(list.Count);
                    $("#events .ui-btn-up-e").removeClass("ui-btn-up-e");
                    if (offer.eventID) $("#event .chances .ui-btn-up-e").removeClass("ui-btn-up-e");
                    $("#ticketList").empty();
                }

                stored.combiTicketAnyPinned = false;

                // Prida odd(s) na tiket
                if ((odds = data.Odds) && odds.length) {

                    // Nastavi signalr, ak nieje pripojeny tak ho inicializuje
                    events.eventsSignalrModule.checkSignalR(events.eventsSignalrModule.setSignalR, events.eventsSignalrModule.initSignalR);

                    // SKUPINOVO-ROZPISOVY TIKET
                    var multi = false;
                    if (data.TYPE !== ticket.state.ticketWsTypes.JT) {
                        multi = true;

                        // Zotriedenie oddov podla skupin (tutovka [1] je na prvom mieste)
                        odds = odds.sort(function (a, b) {
                            return a.Group.localeCompare(b.Group);
                        });

                        // Ulozenie aktualnych kombinacii do globalnych premennych
                        if (data && data.Combi) list.Combi = data.Combi;
                        if (data && data.OddsCombi) list.OddsCombi = data.OddsCombi;

                    }

                    // Vykona sa pre JEDNODUCHY TIKET a SKUPINOVO-ROZPISOVY TIKET

                    // Nastavenie tipNames na domaci / hostia
                    var localizedTip1 = "1", localizedTip2 = "2";
                    if (profile.TipsFormat) {
                        localizedTip1 = texts["EventTip-1"];
                        localizedTip2 = texts["EventTip-2"];
                    }

                    // Pridanie oddov na tiket
                    for (i = 0; i < odds.length; i++) {

                        // Nastavenie tipNames na nazvy teamov
                        if (profile.TipsFormat == "team" || profile.TipsFormat == "teamX") {
                            localizedTip1 = odds[i].Team1;
                            localizedTip2 = odds[i].Team2;
                        }

                        // Nanovo oznaci spravne odds v ponuke
                        if (rebuild) {
                            if ($("#events #" + odds[i].OddID).length) {
                                if (profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                                    $("#events #" + odds[i].EVT).addClass("ui-btn-up-e");
                                }
                                $("#events #" + odds[i].OddID).addClass("ui-btn-up-e");
                            } else {
                                $("#events #" + odds[i].EVT).addClass("ui-btn-up-e");
                            }
                            // Oznaci odds aj v otvorenom evente
                            if (offer.eventID) $("#event #" + odds[i].OddID).addClass("ui-btn-up-e");
                            // Oznaci odds aj v zapasoch dna
                            if ($("#eventsOfDay #" + odds[i].OddID).length) {
                                $("#eventsOfDay #" + odds[i].OddID).addClass("ui-btn-up-e");
                            }
                        }
                        // Ak sa oddID v liste nenachadza tak ho don prida spolu s eventID a vyrenderuje ho na tiket
                        if (rebuild || !ticket.listCheck(odds[i].OddID)) {

                            // Naplini list.Odds a prislusny list.Events
                            list.Odds.push(parseInt(odds[i].OddID));
                            list.Events.push(String(odds[i].EVT));

                            // Lokalizaciu pre TIP
                            switch (odds[i].Tip) {
                                case "1":
                                    odds[i].Tip = localizedTip1;
                                    break;
                                case "X":
                                    odds[i].Tip = texts["EventTip-X"];
                                    break;
                                case "2":
                                    odds[i].Tip = localizedTip2;
                                    break;
                                case "1X":
                                    if (profile.TipsFormat === "teamX" || !profile.TipsFormat) {
                                        odds[i].Tip = "1X";
                                    } else {
                                        odds[i].Tip = localizedTip1 + " " + texts["EventTip-OR"] + " " + texts["EventTip-X"];
                                    }
                                    break;
                                case "X2":
                                    if (profile.TipsFormat === "teamX" || !profile.TipsFormat) {
                                        odds[i].Tip = "X2";
                                    } else {
                                        odds[i].Tip = texts["EventTip-X"] + " " + texts["EventTip-OR"] + " " + localizedTip2;
                                    }
                                    break;
                                case "12":
                                    if (profile.TipsFormat === "teamX" || !profile.TipsFormat) {
                                        odds[i].Tip = "12";
                                    } else {
                                        odds[i].Tip = localizedTip1 + " " + texts["EventTip-OR"] + " " + localizedTip2;
                                    }
                                    break;
                            }
                            // Nastavi "L" ak sa jedna o LIVE a "V" ak sa jedna o VirtualGames
                            var oddLabel = oddClass = oddWrapperClass = oddRemoveHtml = oddOriginalHtml = oddStatusHtml = oddBuyBackcheckHtml = "";
                            if (odds[i].LiveBet) {
                                oddLabel = "L";
                                oddClass = "odd-live";
                                oddWrapperClass = "ticket-odd-live";
                            }
                            if (odds[i].SportID == offer.vgID) {
                                oddLabel = "v";
                                oddClass = "odd-live odd-virtual";
                                oddWrapperClass = "ticket-odd-live";
                                if (odds[i].RegionID == profile.Lottery.RegionID) {
                                    oddWrapperClass += " ticket-odd-lottery";
                                } else {
                                    oddWrapperClass += " ticket-odd-virtual";
                                }
                            }
                            // [Betbuilder Aggregator API] class pre oddy z Betbuilder
                            if (odds[i].IsBetbuilder) {
                                oddWrapperClass += " odd--betbuilder-agg";
                            }
                            if (!multi) {
                                if (odds[i].IsWinning) {
                                    oddWrapperClass += " odd-iswinning-" + odds[i].IsWinning;
                                }
                                if (odds[i].IsEditedEvaluated) {
                                    oddWrapperClass += " odd-buyback-evaluated";
                                }
                                if (odds[i].IsEditedOdd) {
                                    oddWrapperClass += " odd-edited";
                                }
                                if (!odds[i].IsActive || odds[i].IsWinning) {
                                    oddWrapperClass += " odd-inactive";
                                }
                                if (!ticket.ticketEditModule.isOddAvailableForAction("remove", data.IsEdited, odds[i])) {
                                    oddWrapperClass += " odd-non-removable";
                                }
                                if (ticket.ticketEditModule.isOddAvailableForAction("buyback", data.IsEdited, odds[i])) {
                                    oddWrapperClass += " odd-buybackable";
                                }

                                oddRemoveHtml = '<span id="removeOdd" onmousedown="ticket.ticketOddModule.ctRemoveOdd(' + odds[i].OddID + ')"><div class="ui-icon ui-icon-minus"></div></span>';
                                oddOriginalHtml = `<span id="crsOriginal">${odds[i].RateTicket == undefined ? '<span class="icon icon-lock-x"></span>' : (ticket.ticketEditModule.isOddAlreadyBoughtBack(odds[i]) ? shared.floor2(odds[i].Rate, 2) : shared.floor2(odds[i].RateTicket, 2))}</span>`;
                                oddStatusHtml = odds[i].IsEditedEvaluated? '<span class="odd-state odd-status-' + odds[i].IsWinning + '"><div class="state-icon"></div></span>': '';
                                oddBuyBackcheckHtml = '<div id="oddBuyBackWrapper' +
                                    + odds[i].OddID + '" class="odd-buyback-checkbox" onmousedown="ticket.ticketEditModule.oddBuyBackCheckBoxAction(\''
                                    + data.SportBoxTicketGUID + "', '"
                                    + odds[i].OddID + '\')"><input type="checkbox" id="oddBuyBack'
                                    + odds[i].OddID + '"'
                                    + (odds[i].IsWinning == "BB"? 'checked="checked"': '') + '><label class="odd-buyback-label">'
                                    + texts.TicketEditOddBuyBack + '</label><span id="crsBuyback" class="' + odds[i].IsWinning + '">'
                                    + shared.floor2(odds[i].BuyBackValue, 2) + '</span></div>';

                                var simpleTicket = '<li data-ticket-ws="' + `${ ticketWS ? 'yes' : 'no' }` + '" id="' + odds[i].OddID + '" sport-id="'
                                    + odds[i].SportID + '" sport-name="'
                                    + odds[i].SportName + '" class="EVT-'
                                    + odds[i].EVT + ' event-list-item ui-list ui-li ui-li-static ui-btn-up-a '
                                    + oddWrapperClass + '">'
                                    + oddRemoveHtml + oddStatusHtml + '<div class="ui-list-text"><div id="openEvent" onclick="eventDetail.showEventDetail('
                                    + odds[i].EVT + ')"></div><div id="titleRegion" class="sport-bgColor-'
                                    + odds[i].SportID + '"></div><span id="titleHome">'
                                    + odds[i].Team1 + `</span><br><span id="vs"></span><span id="titleAway"></span>${ profile.BetBuilderAgg && odds[i].IsBetbuilder ? '&nbsp;<span class="icon icon-betbuilder--agg betbuilder-agg__icon"></span>' : '' }<div id="titleChanceType"></div><table class="ticket-list"><tr><td id="dateT" width="1%">`
                                    + texts.OddDate + ':</td><td id="date">'
                                    + odds[i].DATE + '</td></tr><tr><td id="betT" width="1%">'
                                    + texts.OddTip + ':</td><td id="bet">'
                                    + odds[i].Tip + '</td></tr></table>'
                                    + oddOriginalHtml + '</div><div id="flg"></div>'
                                     + oddBuyBackcheckHtml + '<div class="'
                                    + oddClass + '">'
                                    + oddLabel + '</div></li>';
                                if (!rebuild && hasOdd) {
                                    if (hasOdd === true) {
                                        $("#ticketList .EVT-" + odds[i].EVT).after(simpleTicket);
                                    } else {
                                        $("#ticketList #" + hasOdd).after(simpleTicket);
                                    }
                                } else {
                                    $("#ticketList").append(simpleTicket);
                                }
                            } else {
                                var ticketTableButtonLottery = "";
                                var hasWinTableLottery = false;
                                if (data?.IsLotteryTicket) {
                                    if (offer.lotteryWinTableECT.includes(odds[i].ChanceTypeID)) {
                                        hasWinTableLottery = true;
                                    }

                                    // Aktualizuje list expandovanych oddov - odstrani z listu exspirovane oddy
                                    list.OddsTicketLotteryExpanded = list.OddsTicketLotteryExpanded.filter(function(oddExpanded) {
                                        if (!list.OddsExpired.includes(oddExpanded)) {
                                            return oddExpanded;
                                         }
                                    });

                                    if (list.OddsTicketLotteryExpanded.includes(odds[i].OddID)) {
                                        oddWrapperClass += ' collapsible-lottery-table-expanded';
                                    }

                                    var ticketTableSpot = odds[i].Tip.split(",").length;
                                    if (ticketTableSpot && odds[i]?.LCUP && list.OddsCombi[i]) {
                                        var toggleLotteryTableButton = "";
                                        if (hasWinTableLottery) {
                                            toggleLotteryTableButton = `<div id='toggleButtonTableLottery${odds[i].OddID}' onmousedown='ticket.ticketLotteryModule.ticketTableLotteryToggle(${odds[i].OddID})' class='lottery-button lottery-button-table-toggle icon icon-arrow-down'></div>`;
                                        }
                                        ticketTableButtonLottery = `
                                            <div>
                                                <div class='lottery-combi-row'>
                                                    <div id='combiBet${list.OddsCombi[i]?.ID}' class='combi-bet-calc bet'>
                                                        <div id='minusButtonBetLottery${odds[i].OddID}' onmousedown='ticket.ticketLotteryModule.setSpellLottery(\"${list.OddsCombi[i]?.ID}\", ${-profile.MinDep}, ${list.OddsCombi[i]?.Bet})' class='lottery-button lottery-bet-button'>-</div>
                                                        <div id='betLottery${list.OddsCombi[i]?.ID}' onmousedown='ticket.ticketCombiModule.selectCombiInput(this);' value='${list.OddsCombi[i]?.Bet}' class='lottery-combi-bet-input' currency='${profile.Currency}'>${shared.floor2(list.OddsCombi[i]?.Bet, 1)}</div>
                                                        <div id='plusButtonBetLottery${odds[i].OddID}' onmousedown='ticket.ticketLotteryModule.setSpellLottery(\"${list.OddsCombi[i]?.ID}\", ${profile.MinDep}, ${list.OddsCombi[i]?.Bet})' class='lottery-button lottery-bet-button'>+</div>
                                                    </div>
                                                    <div class='combi-max-pot-win'>
                                                        <div class='combi-max-min-label'>${(hasWinTableLottery? texts.LotteryBetMaxEvWin: texts.LotteryBetEvWin)}</div>
                                                        <div id='combiMaxWin${odds[i].OddID}' class='combi-max-min-value' currency='${profile.Currency}'>${shared.floor2(list.OddsCombi[i]?.PotWin, 1)}</div>
                                                    </div>
                                                    ${toggleLotteryTableButton}
                                                </div>
                                                <li id='tableTicketLotteryWrapper${odds[i].OddID}' class='ticket-table-lottery-wrapper ${list.OddsTicketLotteryExpanded.includes(odds[i].OddID)? '': 'hide'}'>`
                                                    + ticket.ticketLotteryModule.ticketTableLotteryKenoGenerate(ticketTableSpot, odds[i].LCUP, list.OddsCombi[i].Bet) +
                                                `</li>
                                            </div>
                                        `.replace(/\n/g, ' ').trim();
                                    }
                                }
                                var oddTipLottery = "";
                                var rate = parseFloat(odds[i].Rate).toFixed(2);
                                if (data?.IsLotteryTicket && hasWinTableLottery) {
                                    oddTipLottery = ticket.getLocalizedTip(odds[i].Tip, false, false, data.IsLotteryTicket, true);
                                    // Vyberie kurzy pri pocte zvolenych lopticiek
                                    var rates = Object.values(lotteryOffer["league" + odds[i].LCUP].balls[odds[i].Tip.split(",").length]);
                                    if (rates.length > 1) {
                                        // Ak existuje rozsah kurzov tak prida minimalny kurz
                                        rate = parseFloat(rates[0].pays).toFixed(2) + " - " + rate;
                                    }
                                } else {
                                    oddTipLottery = odds[i].Tip;
                                }
                                $("#ticketList").append('<li data-ticket-ws="' + `${ ticketWS ? 'yes' : 'no' }` + '" id="' + odds[i].OddID + '" sport-id="'
                                    + odds[i].SportID + '" sport-name="'
                                    + odds[i].SportName + '" class="EVT-'
                                    + odds[i].EVT + ' event-list-item ui-list ui-li ui-li-static ui-btn-up-a '
                                    + oddWrapperClass + '" event-id="'
                                    + odds[i].EVT + '" name="'
                                    + odds[i].Group + '"><span id="removeOdd" onmousedown="' 
                                    + `ticket.ticketOddModule.ctRemoveOdd(${odds[i].OddID}, ${odds[i].EVT}, ${odds[i].ChanceTypeID?.split('uf:')[1]}, ${odds[i].LCUP}, ${data.IsLotteryTicket})` + '"><div class="ui-icon ui-icon-minus"></div></span><div class="ui-list-text"><div class="touchable-event" onclick="ticket.checkEvent('
                                    + odds[i].OddID + ')"></div><div id="titleRegion" class="sport-bgColor-'
                                    + odds[i].SportID + '"></div><span id="titleHome">'
                                    + odds[i].Team1 + `</span><br><span id="vs"></span><span id="titleAway"></span>${ profile.BetBuilderAgg && odds[i].IsBetbuilder ? '&nbsp;<span class="icon icon-betbuilder--agg betbuilder-agg__icon"></span>' : '' }<div id="titleChanceType"></div><table class="ticket-list"><tr> <td id="dateT" width="1%">`
                                    + texts.OddDate + ':</td><td id="date">'
                                    + odds[i].DATE + '</td></tr><tr><td id="betT" width="1%">'
                                    + texts.OddTip + ':</td><td id="bet">'
                                    + oddTipLottery + '</td></tr></table><span id="crsOriginal">'
                                    + rate + '</span></div></div><div id="icon-ticket-touch"><img src="'
                                    + url.base + 'stylesheets/images/icon-touch.png"/></div><div id="flg"></div><div class="'
                                    + oddClass + '">' + oddLabel + '</div>' + ticketTableButtonLottery + '</li>');
                            }
                            if (odds[i].Team2) {
                                $("#ticketList #" + odds[i].OddID + " #vs").text("VS");
                                $("#ticketList #" + odds[i].OddID + " #titleAway").text(odds[i].Team2);
                            }
                            if (odds[i].SportName && odds[i].RegionName && odds[i].LeagueCupName) {
                                var divider = " - ";
                                if (ticket.state.getState().isLotteryTicket) {
                                    $("#ticketList #" + odds[i].OddID + " #titleRegion").html(`<span class="title-root sport-bgColor-${odds[i].LCUP}">${odds[i].LeagueCupName}</span><span class="title-root sport-bgColor-${odds[i].LCUP}">${odds[i].Team1}</span>`).removeClass();
                                } else {
                                    $("#ticketList #" + odds[i].OddID + " #titleRegion").text(odds[i].SportName + divider + odds[i].RegionName + divider + odds[i].LeagueCupName);
                                }
                            }
                            if (odds[i].ChanceType) {
                                if (profile.BetBuilderAgg && odds[i].IsBetbuilder) {
                                    // [Betbuilder Aggregator API]  "ChanceType": "Zápas - Výsledok (Riadny hrací čas) | 1 && Zápas - Strelec gólu (Riadny hrací čas) | Gól"
                                    $("#ticketList #" + odds[i].OddID + " #titleChanceType").append(betbuilderAgg.formatAggregatorChanceType(odds[i].ChanceType));
                                } else {
                                    $("#ticketList #" + odds[i].OddID + " #titleChanceType").append(odds[i].ChanceType);
                                }
                            }
                            if (ticket.state.getState().isEditTicket && ((data.IsEdited && ticket.ticketEditModule.isOddAlreadyBoughtBack(odds[i])) || !odds[i].IsActive)) {
                                // Editacia
                                $("#ticketList #" + odds[i].OddID).find(".ui-list-text").addClass("ui-disabled");
                            }
                            if (oddLabel && !odds[i].IsActive) {
                                // Nastavi odd popripade tabulku vyhernosti (loteria) pre dany odd ako disablovanu
                                $("#ticketList #" + odds[i].OddID).children().addClass("ui-disabled").end()
                                .next(".ticket-table-lottery-wrapper").addClass("ui-disabled");
                            }
                        } else if (parseInt(odds[i].OddID) == oddID) {
                            // Ak sa oddID v liste nachadza tak ho v liste posunie na koniec a v tikete aktualizuje
                            ticket.ticketOddModule.oddChangedTicket(odds[i]);
                            ticket.ticketOddModule.addRemoveOddFromList(odds[i]);

                            if (!odds[i].LiveBet) $("#ticketList #" + odds[i].OddID + " .odd-live").remove();
                        }
                    }
                    if (data.IsEdited) {
                        if (rebuild && ticketWS) {
                            if (!$("#ticketForEditInfo").length) {
                                $("#ticketList").prepend('<li id="ticketForEditInfo"><span class="icon-arrow-left-stroke"></span><span id="ticketForEditInfoText">' + texts.TicketEditAddOdds + '</span></li>');
                            }
                        }
                    } else {
                        modal.errorResolver();
                    }
                    if (multi) {
                        // Zoskupenie oddov do skupin pre kombinovany tiket
                        ticket.ticketCombiModule.ctSetGroups(oddID);
                        // Aktivovanie / deaktivovanie tlacitok pre kombinovany tiket
                        ticket.ticketCombiModule.combiOptionToggle();
                    }

                    if (ticketWS) {
                        // Nastavenie limitov
                        ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                        // Rendering Freebetov
                        ticket.ticketPromoModule.ctRenderFreebetBonifications(data);
                    }
                }

                if (multi) {
                    ticket.ticketCombiModule.ctRenderCombinations(data, true, true, true);
                } else {
                    ticket.ticketCombiModule.hideCombinationList(true);
                }

                // Aktualizacia celkoveho kurzu a platobnych udajov
                if (
                    (((data.OverallRateRaw = parseFloat(data.OverallRateRaw)) || data.OverallRateRaw == 0) && (data.OverallRateRaw != stored.Rate))
                    ||
                    ((data.BusinessRate = parseFloat(data.BusinessRate)) && (data.BusinessRate != stored.BusinessRate))
                ) {
                    stored.Rate = data.OverallRateRaw;
                    stored.BusinessRate = data.BusinessRate;

                    // Ak prisli data z ticketWS tak ich preposle na ticket.checkSum()
                    if (ticketWS) {
                        ticket.checkSum(data);
                    } else {
                        ticket.checkSum();
                    }
                }

                // Ak je na tikete aspon jeden odd tak nastavi refresh
                if (rebuild && list.Odds.length) {
                    // Ak nebezi refresh tiketu tak ho spusti schova napovedu
                    if (!rfs.ticket) {
                        $("#ticketHelp").hide();
                        ticket.stopMarkingHelp();
                    }
                    // Nastav casovac na deltu tiketu
                    // Neplati ze sa spoliehame na signalR - https://codium-fsm.atlassian.net/browse/OF-97
                    ticket.setTicketRefresh();
                }

            } else {
                ticket.ticketCheck("reset");
                return false;
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketCheck("reset");
            return false;
        }
    },

    /**
     * Funkcia zmeni zobrazenie tiketu na UI JT/SRT/SRTL/MT
     * @param {string} ticketType        Pozadovany typ tiketu
     */
    changeTicketView: function(ticketType) {
        try {
            // Dlzka tiketu
            var rows = 1, length = 619;
            if (profile.Resolution === "1280x1024") length = 1050;

            if (profile.DisplayFee || profile.BoosterBonus) {
                if (profile.DisplayFee) {
                    rows++;
                    $("#feeText").show();
                } else {
                    length += 18;
                    $("#feeText").hide();
                }
                if (profile.BoosterBonus) {
                    rows++;
                    $("#bonusWrapper").show();
                } else {
                    length += 20;
                    $("#bonusWrapper").hide();
                }
            }
            if (!ticket.state.getState().isEditTicket && (profile.DisplayFee || profile.BoosterBonus)) {
                $("#expandingInfo").show();
            } else if (ticket.state.getState().isEditTicket) {
                length += 41;
                rows = 0;
                $("#expandingInfo").hide();
            }

            $(".content-ticket").find(".pulse").removeClass("pulse").end()
            .find(".deposit-display .ui-grid-a.flat-possible-win").removeClass().addClass("ui-grid-a flat-possible-win flat-" + rows + "-row");

            switch (ticketType) {
                case ticket.state.ticketWsTypes.JT:
                // JEDNODUCHY TIKET

                    $("#freebetList #triangle, #bonificationList #triangle").addClass("triangle-" + length);
                    $("#ticketTop .content-ticket-bg").height(length - 2);
                    $("#ticket").animate({maxHeight: length + "px"}, 0).removeClass("is-my-tickets edit-mode");
                    // Nastavi tiket
                    $("#ticketList").removeClass("combi edit-history").find(".group").replaceWith($("#ticketList li"));
                    $("#ticketList").find(".touchable-event, *#icon-ticket-touch").hide();
                    $("#ticketList li").removeClass("checked");
                    $("#ticketList").show();

                    // Nastavi buttony pod tiketom (footer-sider)
                    $("#footer-sidebar .simple-options, #footer-sidebar #rateChanges").show();
                    $("#footer-sidebar #rateText, #footer-sidebar #rate").css('visibility', 'visible');
                    $("#footer-sidebar .combi-options").hide();
                    $("#footer-sidebar span.overall-bet").empty();

                    // Nastavi kalkulacku
                    $("#depositDial").removeClass("calculator-srt calculator-srtl").addClass("calculator-jt");
                    $("#depositDial #displayDial").removeClass("selected-input");
                    $("#depositDial").find("#lotterySingleStake").removeClass("selected-input");
                    $("#depositDial #displayDial .multiplier").removeAttr("currency");
                    $("#footer-sidebar .deposit-display").show();

                    stored.inputElement = $("#depositDial #displayDial").addClass("selected-input");

                    // Skryje moje tikety
                    $("#myTicketsContainer").hide();

                    // Nastavi freebet a bononus buttony
                    ticket.ticketPromoModule.freebetBonificationShowButtons(ticket.state.getState().isEditTicket);

                    // Nastavi tiket tab
                    ticket.state.setState({tab: ticket.state.ticketTabs.JT});

                break;
                case ticket.state.ticketWsTypes.SRT:
                // SKUPINOVO-ROZPISOVY TIKET

                    $("#combinationList #triangle").addClass("triangle-" + length);
                    profile.Resolution == "1280x1024" ? length += 8 : length += 17;
                    if (ticket.state.getState().isLotteryTicket) {
                        length += 60;
                    }
                    $("#ticketTop .content-ticket-bg").height(-2 + (length -= 70));
                    $("#ticket").animate({maxHeight: length + "px"}, 0).removeClass("is-my-tickets edit-mode");

                    // Nastavi tiket
                    $("#ticketList").addClass("combi").show();
                    // Nastavi buttony pod tiketom (footer-sider)
                    $("#footer-sidebar .simple-options").hide();
                    $("#footer-sidebar .combi-options, #footer-sidebar #rateChanges").show();
                    $("#footer-sidebar span.stake-bet").empty().attr("currency", profile.Currency);
                    $("#footer-sidebar span.deposit").empty();
                    // Nastavi kalkulacku
                    $("#depositDial").find("#lotterySingleStakeValue").removeClass("selected-input");
                    $("#depositDial #displayDial .deposit").removeAttr("currency");

                    stored.inputElement = $("#depositDial #displayDial").addClass("selected-input");

                    // Skryje moje tikety
                    $("#myTicketsContainer").hide();
                    $("#footer-sidebar .deposit-display").show();

                    // Tiket zobrazenie specificke pre loteriu
                    if (ticket.state.getState().isLotteryTicket) {
                        // Nastavi lotery tlacitka tiketu
                        $("#footer-sidebar .combi-options .first-row").hide();
                        $("#footer-sidebar .combi-options .second-row .ui-block-a, #footer-sidebar .combi-options .second-row .ui-block-b").hide();
                        $("#footer-sidebar .combi-options .second-row").removeClass().addClass("second-row ui-grid-a");
                        ticket.ticketPromoModule.freebetBonificationShowButtons(true);
                        // Nastavi lotery kalkulacku
                        $("#depositDial").removeClass("calculator-jt calculator-srt").addClass("calculator-srtl");
                        // $("#ticketTabs").addClass("ticket-tab-srtl");
                        // Nastavi tiket tab
                        ticket.state.setState({tab: ticket.state.ticketTabs.SRTL});
                    } else {
                        // Nastavi default tlacitka tiketu
                        $("#footer-sidebar .combi-options .first-row").show();
                        // Nastavi default kalkulacku
                        $("#depositDial").removeClass("calculator-jt calculator-srtl").addClass("calculator-srt");
                        // Nastavi tiket tab
                        ticket.state.setState({tab: ticket.state.ticketTabs.SRT});
                    }
                break;
                case ticket.state.ticketTabs.MT:
                // MOJE TIKETY
                    // Nastavi zobrazenie pre Moje tikety
                    profile.Resolution == "1280x1024" ? stored.myTicketsContainerLength = 1166 : stored.myTicketsContainerLength = 718;
                    $("#ticketTop .content-ticket-bg").height(0);
                    $("#ticket").animate({maxHeight: stored.myTicketsContainerLength + "px"}, 0).addClass("is-my-tickets edit-mode");
                    $("#myTicketsContainer").height(stored.myTicketsContainerLength).animate({maxHeight: stored.myTicketsContainerLength + "px"}, 0);
                    $("#ticket #myTicketsList").height(stored.myTicketsContainerLength).animate({maxHeight: stored.myTicketsContainerLength + "px"}, 0);
                    // Skryje moznosti
                    $("#footer-sidebar .deposit-display, #footer-sidebar .combi-options, #footer-sidebar #rateChanges").hide();
                    $("#footer-sidebar #flexGrid").removeClass().addClass("flex-2");
                    // Nastavi tiket tab
                    ticket.state.setState({tab: ticket.state.ticketTabs.MT});
                break;
            }
        } catch(e) {
            throw e;
        }
    },

    state:(function() {
        // Mozne typy tiketov nastavene na tiketovej sluzbe
        const ticketWsTypes = {
            JT: "JT",
            SRT: "SRT"
        };

        // Typy tabov v casti tiketov
        const ticketTabs = {
            JT: "JT",                               // Jednoduchy tiket
            SRT: "SRT",                             // Skupinovo rozpisovy tiket
            SRTL: "SRTL",                           // Skupinovo rozpisovy tiket - loptickove hry
            MT: "MT"                                // Moje tikety
        };

        // Nastavenie hodnoty na tiketovej sluzbe
        let _type = "JT";
        let _isLotteryTicket = false;
        let _isEditTicket = false;
        let _isClonedTicket = false;
        let _liveBetDelayMs = 0;
        let _isWinCurrencyTicket = false;

        // Ulozenie a prepnutie typu tabu
        function _setTicketTab(tab) {
            if (Object.keys(ticketTabs).includes(tab)) {
                $("#ticketTabs [data-type]")
                    .removeClass("active-type lock-btn")
                    .addClass("inactive-type")
                    .parent().find("[data-type='" + tab + "']")
                    .addClass("active-type lock-btn");
                // Ak je ticket tab ticket-tab-srtl (tiket s loptickovymi hrami) nastavi zobrazenie s 1 tabom 
                $("#ticketTabs").removeClass().addClass("ui-grid-c ticket-tab-" + tab.toLowerCase());
                return true;
            }
            return false;
        }

        // Nastavenie
        function setState(stateTicket) {
            if (typeof stateTicket.type !== 'undefined' && Object.keys(ticketWsTypes).includes(stateTicket.type)) _type = stateTicket.type;
            if (typeof stateTicket.isLotteryTicket !== 'undefined') _isLotteryTicket = stateTicket.isLotteryTicket;
            if (typeof stateTicket.isEditTicket !== 'undefined') _isEditTicket = stateTicket.isEditTicket;
            if (typeof stateTicket.isClonedTicket !== 'undefined') _isClonedTicket = stateTicket.isClonedTicket;
            if (typeof stateTicket.tab !== 'undefined') _setTicketTab(stateTicket.tab);
            if (typeof stateTicket.liveBetDelayMs !== 'undefined') _liveBetDelayMs = stateTicket.liveBetDelayMs;
            if (typeof stateTicket.isWinCurrencyTicket !== 'undefined') _isWinCurrencyTicket = stateTicket.isWinCurrencyTicket;
            if (profile.ConsoleLog || profile.ConsoleLog$.Ticket) {
                console.log(
                "%csetState:\n" + JSON.stringify({
                    type: _type,
                    isLotteryTicket: _isLotteryTicket,
                    isEditTicket: _isEditTicket,
                    isClonedTicket: _isClonedTicket,
                    actualTab: $("#ticketTabs .active-type").attr("data-type"),
                    liveBetDelayMs: _liveBetDelayMs,
                    isWinCurrencyTicket: _isWinCurrencyTicket
                }, null, 2),
                "color: red;"
                );
            }
        }

        // Porovnanie s nastavenym typom tiketu na tiketovej sluzbe
        function isTicketWsType(type) {
            return _type === type;
        }

        // Ziskanie stavu tiketu
        function getState() {
            return {
                type: _type,
                isLotteryTicket: _isLotteryTicket,
                isEditTicket: _isEditTicket,
                isClonedTicket: _isClonedTicket,
                actualTab: $("#ticketTabs .active-type").attr("data-type"),
                liveBetDelayMs: _liveBetDelayMs,
                isWinCurrencyTicket: _isWinCurrencyTicket
            };
        }

        return {
            ticketWsTypes,
            ticketTabs,
            setState,
            isTicketWsType,
            getState
        };
    })(),

    // Funkcia na spracovanie tiketu - uspesne odoslany, prazdny alebo je celkom vymazany (reset / clear)
    ticketCheck: function(action, retrieve, isLogout) {
        try {
            // Zastavi ticket refresh, vymaze listy a ulozene premenne
            ticket.stopTicketRfs();
            delete stored.ticket;
            stored.OverallFee = stored.Rate = stored.BusinessRate = 0;
            stored.GUID = stored.BonusMoney = null;
            stored.submitting = false;
            ticket.state.setState({liveBetDelayMs: 0});
            stored.darkScreen = sets.darkScreen;
            odds = [];
            list.Odds = [];
            list.Events = [];
            list.Count = list.Sync = 0;
            list.Combi = [];
            list.OddsCombi = [];
            list.OddsExpired = [];
            list.OddsExpiredHidden = [];
            list.OddsRateChanged = [];

            // Zastavi signalR pre zmenu kurzov na tikete
            events.eventsSignalrModule.setSignalR();

            // Zrusi maxBet
            stored.BetAll = false;
            $(".bet-all .ui-btn").removeClass("ui-btn-active");
            document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");

            // Ak prebehol submit tak vymaze vysku vkladu
            if (action == "reset" || stored.anyApplicableFb) {
                main.unlockApp();
                ticket.calc("clear");
                // Vymaze ticket na ticketWS
                if (!retrieve) ticket.ticketWsReset(false, isLogout);
            } else {
                // Skryje deposit kalkulacku a kombinacie
                ticket.depositDialToggle(true);
                if (action === "clear") {
                    // Spristupni tiket tlacitka
                    main.unlockSbmButtons();
                }
            }

            // Skryje freebet alebo bonifikaciu
            ticket.ticketPromoModule.clearFreebetBonification(true);

            // Vymaze tiket a odznaci vsetky odds
            $("#ticketList").empty();
            $("#footer-sidebar .deposit-display").find("#rate, #fee, #bonus, #summary").empty().removeAttr("currency");
            $("#footer-sidebar .deposit-display #rate").text("0.00");
            $("#sportBox .content-table .ui-btn-up-e").removeClass("ui-btn-up-e");
            if (offer.eventID) $("#event .chances .ui-btn-up-e").removeClass("ui-btn-up-e");
            $(".ticket-header__item--tips .ticket-header__value").text(0);

            // Ak nieje hrac prihlaseny, zobrazi napovedu ak je tiket prazdny 10 sekund
            if (!stored.PlayerID) {
                // Skryje deposit kalkulacku a kombinacie
                ticket.showHelp();
                if(!$("#ticketHelp").is(':visible')) {
                    $("#ticketHelp").show()
                    ticket.depositDialToggle(true);
                }
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.startApp(1);
            return false;
        }
    },

    // Funkcia na odoslanie formulara pri podani tiketu
    submitTicket: function(bet, comboID) {
        try {
            // Zamknutie terminalu pocas podavania tiketu a zobrazenie odpocitavania
            stored.darkScreen = sets.darkScreen + ticket.state.getState().liveBetDelayMs;
            main.lockApp(null, null, null, ticket.state.getState().liveBetDelayMs / 1000);

            // Pocas odosielania zastavi vsetky refresh (signalR necha bezat)
            stored.submitting = true;
            main.stopAllRfs(true);

            // Zrusi pripadne opatovne zavolanie ctSetBet
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && stored.CombiTimerActive) {
                clearTimeout(rfs.ctSetBet);
                stored.CombiTimerActive = false;
            }

            // Zrusi zadavanie centov
            stored.Decimal = false;
            $("#calcComma .ui-btn").removeClass("ui-btn-active");

            // Skryje kombinacie
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) ticket.ticketCombiModule.hideCombinationList();

            var betValue, comboValue, sRate;
            // Nastavenie atributu BET
            if (!bet) {
                betValue = stored.OverallTotalBet;
            } else {
                betValue = bet;
            }
            // Ak je tiket podavany s parametrom ComboID tak sa pripravia data pre atribut COMBO, a nastavi sa Rate
            if (!comboID) {
                sRate = stored.Rate;
            } else {
                comboValue = JSON.stringify(list.Combo[comboID - 1]);
                sRate = "combo";
            }

            // GET TICKET GUID
            if (betValue && ticket.getGUID()) {

                // Ziskanie GUID bolo uspesne -> SUBMIT TICKET
                try {
                    var requestUrl, placebet = "/placebetsb", playerID = reference = "";
                    // Ak je hrac prihlaseny do vernostneho systemu a nejedna sa o manualne verifikovaneho hraca
                    if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
                        var isWinCurrencyBet = ticket.state.getState().isWinCurrencyTicket;
                        placebet = (isWinCurrencyBet ? "/placebetsbwin" : "/placebetsbloyal");
                        playerID = "/" + stored.PlayerID;
                        if (stored.WebBalanceActive && stored.MoneyTransferReference && !ticket.state.getState().isEditTicket && !isWinCurrencyBet) {
                            placebet = "/placebetsbloyalmoneytransfer";
                            reference = "/" + stored.MoneyTransferReference;
                        }
                        main.createLog(3, "TicketSubmit_InProgress", "GUID: " + ticket.anonymGuid(stored.GUID)
                            + " # BET: " + betValue
                            + " # RATE: " + sRate
                            + " # PlayerID: " + stored.PlayerID
                            + " # MoneyTransferReference: " + stored.MoneyTransferReference);
                    } else {
                        main.createLog(3, "TicketSubmit_InProgress", "GUID: " + ticket.anonymGuid(stored.GUID)
                            + " # BET: " + betValue
                            + " # RATE: " + sRate);
                    }
                    requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + placebet + "/SBID_" + stored.SBID + "/" + stored.GUID + playerID + reference;
                    xhr = $.ajax({
                        type: "GET",
                        url: requestUrl,
                        dataType: "json",
                        timeout: sets.submitTimeout + ticket.state.getState().liveBetDelayMs,
                        async: true
                    })
                        .done(function (data) {
                            // Kontrola objektu - tiket
                            if (data === Object(data)) {
                                ticket.ticketSubmitCheck(data, betValue, sRate, comboID);
                            } else {
                                // Ak server vratil not-object odpoved
                                ticket.ticketReSubmit(betValue, sRate, comboID, "GUID: " + ticket.anonymGuid(stored.GUID) + " # AJAX FAILED: not-object");
                            }
                            return true;

                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            // Ak zlyha spojenie pocas podavania tiketu tak sa posle na nativeApp ziadost na storno tiketu
                            ticket.ticketReSubmit(betValue, sRate, comboID, "GUID: " + ticket.anonymGuid(stored.GUID) + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                            return false;
                        });

                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    ticket.ticketReSubmit(betValue, sRate, comboID, "GUID: " + ticket.anonymGuid(stored.GUID) + " # ERROR " + e.type);
                    return false;
                }

            } else {
                // GET TICKET GUID zlyhalo alebo nebola nastavena hodnota BET
                main.createLog(2, "TicketSubmit_Failed_Err", "ERROR in: ticket.submitTicket() # GUID: " + ticket.anonymGuid(stored.GUID) + " # BET: " + betValue + " # RATE: " + sRate + " # PlayerID: " + stored.PlayerID);
                stored.submitting = false;
                setTimeout(function () {
                    main.unlockApp();
                    main.unlockSbmButtons(true);
                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) ticket.ticketCombiModule.showCombinationList();
                }, 500);
                modal.showErrObj(1, 5, {err1: texts.TicketErr08, errType: "TicketErr08"});
                ticket.setTicketRefresh();
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "TicketSubmit_Failed_Err", "ERROR in: ticket.submitTicket() # " + e);
            return false;
        }
    },

    // Funkcia na opatovne skontrolovania ci presiel tiket
    ticketReSubmit: function(betValue, sRate, comboID, errLog) {
        try {
            main.createLog(3, "TicketSubmit_ReSubmit", "GUID: " + ticket.anonymGuid(stored.GUID));
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticketcheck/" + stored.GUID + "/onsportbox/" + stored.SBID)
                .done(function (data) {
                    // Kontrola objektu - tiket
                    if (data === Object(data)) {

                        ticket.ticketSubmitCheck(data, betValue, sRate, comboID);
                        return true;

                    } else {
                        // Ak server vratil not-object odpoved
                        ticket.ticketFailed("TicketSubmit_Failed_Err", errLog);
                        return false;
                    }
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    ticket.ticketFailed("TicketSubmit_Failed_Err", errLog);
                    return false;
                });

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "TicketSubmit_Failed_Err", "ERROR in: ticket.ticketReSubmit() # " + e);
            return false;
        }
    },

    // Funkcia na kontrolu podania tiket
    ticketSubmitCheck: function(data, betValue, sRate, comboID) {
        try {
            var errLog;
            // Ak bol tiket prijaty alebo je v procese schvalovania
            if (data && data.PlaceBetDate && (data.PlaceBetState == "approved" || data.PlaceBetState == "waiting_approval")) {

                // Ak tiket obsahuje vsetky klucove udaje tak skontroluje ci sa zhoduju
                if (data.SportBoxTicketGUID && data.OverallTotalBet && data.OverallBet && data.OverallRateRaw && data.OverallPotWin && data.Odds) {

                    // Ak vsetky prijate klucove udaje suhlasia s odoslanymi tak prejde na vyhodnotenie tiketu
                    if (data.SportBoxTicketGUID == stored.GUID) {

                        ticket.ticketSubmitted(data, comboID);
                        return true;

                    } else {

                        // Ak nesuhlasil niektory z klucovych parametrov objektu tiket
                        errLog = "GUID: " + ticket.anonymGuid(data.SportBoxTicketGUID)
                            + " # BET: " + data.OverallTotalBet
                            + " # FEE: " + data.OverallFee
                            + " # RATE: " + data.OverallRate
                            + " # WIN: " + data.OverallPotWin
                            + " # WINFISCAL: " + data.FiscalOverallPotWin
                            + " # CREATED: " + data.PlaceBetDate
                            + " <> [GUID: " + ticket.anonymGuid(stored.GUID)
                            + " # BET: " + betValue
                            + " # Fee: " + stored.OverallFee
                            + " # RATE: " + sRate + "]";

                        // Dodatocna kontrola oddov
                        if (data.Odds) {
                            for (i = 0; i < data.Odds.length; i++) {
                                ticket.ticketOddModule.addRemoveOddFromList(data.Odds[i]);
                            }
                            modal.errorResolver();
                        }
                        ticket.ticketFailed("TicketSubmit_Mismatch", errLog, data.Errors);
                        return false;
                    }

                } else {
                    // Ak chybal niektory z klucovych parametrov objektu tiket
                    errLog = "GUID: " + ticket.anonymGuid(data.SportBoxTicketGUID)
                        + " # BET: " + data.OverallTotalBet
                        + " # FEE: " + data.OverallFee
                        + " # RATE: " + data.OverallRate
                        + " # WIN: " + data.OverallPotWin
                        + " # WINFISCAL: " + data.FiscalOverallPotWin
                        + " # CREATED: " + data.PlaceBetDate
                        + " <> [GUID: " + ticket.anonymGuid(stored.GUID)
                        + " # BET: " + betValue
                        + " # Fee: " + stored.OverallFee
                        + " # RATE: " + sRate + "]";

                    // Dodatocna kontrola oddov
                    if (data.Odds) {
                        for (i = 0; i < data.Odds.length; i++) {
                            ticket.ticketOddModule.addRemoveOddFromList(data.Odds[i]);
                        }
                        modal.errorResolver();
                    }
                    ticket.ticketFailed("TicketSubmit_Failed_MissErr", errLog, data.Errors);
                    return false;
                }

            } else if (data && !data.PlaceBetDate) {
                // Ak tiket nebol prijaty
                errLog = "GUID: " + ticket.anonymGuid(stored.GUID)
                    + " # BET: " + betValue
                    + " # FEE: " + stored.OverallFee
                    + " # RATE: " + sRate
                    + " # DATA BET: " + data.OverallTotalBet
                    + " # DATA FEE: " + data.OverallFee
                    + " # DATA RATE: " + data.OverallRate
                    + " # STORED WIN CURRENCY FUNDED: " + stored.WinCurrencyFunded
                    + " # DATA WIN CURRENCY BALANCE: " + data.WincurrencyClientBalance
                    + " # STORED WIN CURRENCY BALANCE: " + stored.WinCurrencyClientBalance
                    + " # STORED BALANCE: " + stored.Balance
                    + " # ERROR: " + JSON.stringify(data.Errors);

                // Dodatocna kontrola oddov
                if (data.Odds) {
                    for (i = 0; i < data.Odds.length; i++) {
                        ticket.ticketOddModule.addRemoveOddFromList(data.Odds[i]);
                    }
                    modal.errorResolver();
                }
                ticket.ticketFailed("TicketSubmit_Failed", errLog, data.Errors);

                // Nastavi max deposit
                ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                // Spravi checkSum
                ticket.checkSum(data);
                return false;

            } else {
                // V redise bol stary, uz podany tiket
                ticket.ticketFailed("TicketSubmit_Failed_Err", "ALREADY PLACEBET");
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketSubmitCheck() # " + e);
            return false;
        }
    },

    // Funkcia na zrusenie tiketu pri chybe
    ticketFailed: function(logErrKey, errLog, errors, stornoMsg) {
        try {
            var ticketCanceled = false;

            if (logErrKey) {
                if (errors && errors.includes("ERR_PLAYER_NOT_VERIFIED;")) {
                    // Zobrazenie modalneho okna namiesto Error hlasky
                    modal.openVLCModal("PLAYER_NOT_VERIFIED");
                    errors = false;
                }
                // Nastavi popis storna
                if (!stornoMsg) stornoMsg = "SbStorno";

                if (logErrKey == "TicketSubmit_Failed") {
                    // Refresh tiketu s uvodnou deltou
                    ticket.setTicketRefresh(); // namiesto service.loadPure('ticket')
                    ticket.ticketDelta();
                    // Ak je to kombinovany tiket tak sa otovri list kombinacii
                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) ticket.ticketCombiModule.showCombinationList();
                } else {
                    // Ak bol tiket v inom stave ako neprijaty tak ho odroluje
                    try {
                        if (stored.GUID && stored.ticket) {
                            ActionTicketStorno(stored.GUID, stornoMsg, stored.ticket.IsEdited, Math.round(stored.ticket.OverallTotalBet * 100), stored.ticket.WinCurrencyFunded);
                            ticketCanceled = true;
                        } else if (stored.GUID) {
                            // Ak nativeApp dostane len 2 argumenty, tak pre zvysne argumenty pouzije default hodnoty args[2] = false, args[3] = 0
                            ActionTicketStorno(stored.GUID, stornoMsg);
                            ticketCanceled = true;
                        }
                    } catch (e) {
                        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                        main.createLog(2, "TicketSubmit_Failed_Err", "ERROR in: ActionTicketStorno() # " + e);
                    }
                    // Reset tiketu
                    ticket.ticketCheck("reset");
                }

                if (errLog) {
                    main.createLog(2, logErrKey, errLog);
                } else {
                    main.createLog(2, logErrKey, "GUID: " + ticket.anonymGuid(stored.GUID));
                }
            }

            // Zobrazenie error hlasky
            if (errors) {
                errors = modal.parseErrors(errors);
                modal.showErrObj(1, 5, {errObj: errors});
            } else if (errors != false) {
                modal.showErrObj(1, 5, {err1: texts.TicketErr08, errType: "TicketErr08"});
            }

            delete stored.ticket;
            stored.GUID = stored.BonusMoney = null;
            stored.submitting = false;

            main.unlockApp();
            main.unlockSbmButtons(true);

            return ticketCanceled;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "TicketSubmit_Failed_Err", "ERROR in: ticket.ticketFailed() # " + e);
            return false;
        }
    },

    // Funkcia zabezpeci vratenie GUID, inak vrati false
    getGUID: function() {
        try {
            var result, c = 0;
            stored.GUID = stored.BonusMoney = null;

            try {
                while (!(result = (stored.IsEdited? ActionEditedTicketPrepare(): ActionTicketPrepare())) && c != 2) c++;
            } catch (e) {
                return false;
            }

            if (result) {
                try {
                    result = JSON.parse(result);
                    stored.GUID = result.GUID;
                    stored.BonusMoney = result.FomBonus;
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    // Kompatibilne aj s navratovou hodnotou priamo v return
                    stored.GUID = result;
                }
                return true;

            } else {
                // ERROR - nepodarilo sa ziskat GUID pri podani tiketu (3 pokusy)
                main.unlockApp();
                main.createLog(2, "InitGUID_Failed");
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "TicketSubmit_Failed", "ERROR in: ticket.getGUID() # " + e);
            return false;
        }
    },

    // Funckia na vyhodnotenie odoslaneho tiketu
    ticketSubmitted: function(data, comboID) {
        try {
            // Resetne sa timeout - main.stopLock()
            main.lockApp();

            // Ak bol tiket uspesne prijaty a existuje object data
            if (data) {
                // Premeni string na float
                data.OverallBet = parseFloat(data.OverallBet);
                data.OverallFee = parseFloat(data.OverallFee);
                // Prida lokalized tip podla nastavenia
                data.Odds = data.Odds.map(function(odd) {
                    odd.LocalizedTip = ticket.getLocalizedTip(odd.Tip, odd.Team1, odd.Team2, data.IsLotteryTicket, false);
                    return odd;
                });
                // Ulozi tiket pre neskorsie spracovanie a tlac
                stored.ticket = data;
                // Ulozi default log pre pripad uspesneho prijatia tiketu
                stored.ticket.SubmittedLog = "TicketSubmit_Successful";
                if (comboID) stored.ticket.ComboID = comboID;

                // Ak je tiket prijaty a potvrdeny automaticky
                if (data.PlaceBetState == "approved") {
                    // Moznost zapojit sa do sutaze (za bonusovy kredit sa do zutaze nie je mozne zapojit)
                    if (stored.ticket.TicketCompetitions && stored.ticket.TicketCompetitions.length && !stored.BonusMoney) {
                        ticket.ticketPromoModule.ticketCompetitionSet();
                    } else {
                        // Bez moznosti sutaze
                        ticket.ticketSuccess(null);
                    }
                    // Zmaze pouzite GUID
                    stored.GUID = stored.BonusMoney = null;
                    main.unlockSbmButtons(true);

                } else if (data.PlaceBetState == "waiting_approval") {
                    // Ak ma ist tiket na potvrdenie tak prejde na stranku ticketApprove
                    ticket.ticketToApproval();
                    main.createLog(3, "TicketSubmit_ToApprove", "GUID: " + ticket.anonymGuid(stored.GUID) + " # BET: " + stored.ticket.OverallBet);
                }
                // GA4 - trackovanie podania ticketu - sporty a virtualky
                try {                
                    gtag('event', 'purchase', {
                        "transaction_id": data.SportBoxTicketGUID,
                        "value": data.OverallTotalBet,
                        "currency": profile.Default.CurrencyCode,
                        "items": data.Odds.map(function(odd) {
                            return {
                                'item_id': data.TYPE,
                                'item_category': odd.SportName,
                                'item_category2': odd.RegionName,
                                'item_category3': odd.LeagueCupName
                            }
                        })
                    });
                } catch (error) {
                    console.error(error);
                }
            } else {
                ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketSubmitted() # NO DATA -> TICKET RETRIEVE");
                ticket.ticketWsRetrieve();
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketSubmitted() # " + e);
            return false;
        }
    },

    // Funkcia na spustenie schvalovania tiketu kurzarmi
    ticketToApproval: function() {
        try {
            var t = 0;
            main.unlockApp();
            $("#ticketApprove a").addClass("ui-disabled");
            dialog.open({
                id: "ticketApprove",
                persistent: true,
                backdropDismiss: false
            });
            modal.showLoading(sets.clientRefused * (sets.deltaApproval / 1000), true);

            // Nastavi premennu ze prebieha schvalovanie tiketu
            stored.ticketApprovalInProgress = true;
            // Nastavi velkost loadera
            if (profile.LargeTicketApproveLoader) {
                setTimeout(function() {
                    $(".ui-loader").addClass("large");
                });
            }
            // V intervale 2 sekundy overuje ci sa zmenil stav tiketu a pocita pocet pokusov
            rfs.approve = setInterval(function () {
                t++;
                ticket.ticketApprove(t);
            }, sets.deltaApproval);
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $(".ui-loader").removeClass("large");
            main.closeDialog();
            main.unlockApp();
            main.unlockSbmButtons(true);
            return false;
        }
    },

    // Funkcia na overenie potvrdenia tiketu kurzarmi
    ticketApprove: function(a) {
        try {

            // V pravidelnych intervaloch overuje ci bol tiket schvaleny
            if (stored.ticket && stored.GUID && a && a < sets.autoRefused && main.initWebAppCheck()) {
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/refresh")
                    .done(function (data) {
                        if (data === Object(data) && data.PlaceBetState) {
                            // Ak tiket zmeni stav z cakajuceho na prijem
                            if (data.PlaceBetState != "waiting_approval") {
                                // Resetnem premennu ze prebieha schvalovanie tiketu
                                stored.ticketApprovalInProgress = false;
                                ticket.ticketApproved(data);
                            } else if (a >= sets.clientRefused) {
                                // Ak je pocet neuspesnych pokusov viac ako 30 (sets.clientRefused - 1 min) tak zobrazi tlacitko na zrusenie
                                $("#ticketApprove a").removeClass("ui-disabled");
                                main.userAction();
                            }
                        } else {
                            // Ak je su data prazdne alebo neobsahuju atribut PlaceBetState tak
                            ticket.ticketApproveCheck(a);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        if (a >= sets.clientRefused) {
                            $("#ticketApprove a").removeClass("ui-disabled");
                            main.userAction();
                        }
                    });
            } else {
                // Ak nema GUID alebo je pocet neuspesnych pokusov viac ako 150 (sets.autoRefused - 5 min) tak tiket zrusi
                ticket.ticketApproveRefused(a);
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticketAprrove() # " + e);
            return false;
        }
    },

    // Funkcia na dodatocne overenie stavu prijmaneho tiketu
    ticketApproveCheck: function(a, secondCheck) {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticketcheck/" + stored.GUID + "/onsportbox/" + stored.SBID)
                .done(function (data) {
                    if (data && data.PlaceBetState != "waiting_approval") {
                        // Resetnem premennu ze prebieha schvalovanie tiketu
                        stored.ticketApprovalInProgress = false;
                        ticket.ticketApproved(data);
                    } else if ((!a || a >= sets.autoRefused) && rfs.approve) {
                        ticket.ticketApproveRefused(true);
                    }
                    return true;
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    if (secondCheck && rfs.approve) {
                        ticket.ticketApproveRefused(true);
                    } else if (rfs.approve) {
                        ticket.ticketApproveCheck(a, true);
                    }
                    return false;
                });

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Resetnem premennu ze prebieha schvalovanie tiketu
            stored.ticketApprovalInProgress = false;
            return false;
        }
    },

    // Funkcia na stornovanie tiketu na prijme
    ticketApproveRefused: function(a) {
        try {
            // Resetnem premennu ze prebieha schvalovanie tiketu
            stored.ticketApprovalInProgress = false;

            clearInterval(rfs.approve);
            rfs.approve = null;
            main.lockApp();
            main.closeDialog();

            var logErrKey, errLog, stornoMsg;
            if (!a) {
                logErrKey = "TicketSubmit_ClientRefused";
                stornoMsg = "ClientRefused";
            } else {
                logErrKey = "TicketSubmit_AutoRefused";
                stornoMsg = "AutoRefused";
            }
            if (stored.ticket) {
                errLog = "GUID: " + ticket.anonymGuid(stored.GUID)
                    + " # BET: " + stored.ticket.OverallTotalBet
                    + " # FEE: " + stored.ticket.OverallFee
                    + " # RATE: " + stored.ticket.OverallRate
                    + " # WIN: " + stored.ticket.OverallPotWin
                    + " # WINFISCAL: " + stored.ticket.FiscalOverallPotWin
                    + " # CREATED: " + stored.ticket.PlaceBetDate
                    + " # ISEDITED: " + stored.ticket.IsEdited;
            } else {
                errLog = "GUID: " + ticket.anonymGuid(stored.GUID);
            }
            ticket.ticketFailed(logErrKey, errLog, false, stornoMsg);
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketApproveRefused() # " + e);
        }

        ticket.ticketClear(true);
        modal.showErrObj(1, 5, {err1: texts.TicketErr09, errType: "TicketErr09"});
        main.userAction();
        return true;
    },

    // Funkcia ktora sprocesuje tiket prijaty/neprijaty kurzarmi
    ticketApproved: function(data) {
        try {
            // Resetne sa timeout - main.stopLock()
            main.lockApp();

            clearInterval(rfs.approve);
            rfs.approve = null;
            main.closeDialog();

            if (data && stored.ticket) {

                // Ak je tiket schvaleny
                if (data.PlaceBetState == "approved") {

                    // Upravi log o prijme tiketu - tiket bol schvaleny kurzarmi
                    stored.ticket.SubmittedLog = "TicketSubmit_Successful_Approved";
                    // Ak je tiket prijaty a schvaleny (moznost zapojit sa do sutaze)
                    if (stored.ticket.TicketCompetitions && stored.ticket.TicketCompetitions.length) {
                        setTimeout(function () {
                            ticket.ticketPromoModule.ticketCompetitionSet();
                        }, 500);
                    } else {
                        // Ak je tiket prijaty a schvaleny (bez moznosti sutaze)
                        ticket.ticketSuccess(null);
                    }

                } else if (data.PlaceBetState != "approved") {
                    // Tiket neschvaleny
                    main.createLog(2, "TicketSubmit_NotApproved", "GUID: " + ticket.anonymGuid(stored.GUID)
                        + " # BET: " + stored.ticket.OverallTotalBet
                        + " # FEE: " + stored.ticket.OverallFee
                        + " # RATE: " + stored.ticket.OverallRate
                        + " # WIN: " + stored.ticket.OverallPotWin
                        + " # WINFISCAL: " + stored.ticket.FiscalOverallPotWin
                        + " # CREATED: " + stored.ticket.PlaceBetDate);
                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                    if (errors[0] && errors[1]) errors[0] = "<ul><li>" + errors[0] + "</li><li>" + errors[1] + "</li></ul>";
                    modal.showErrObj(1, 5, {err1: texts.TicketErr15, errObj: errors, errType: "TicketErr15"});
                    ticket.ticketClear(true);
                    main.unlockApp();
                }

            } else {
                // Ak nema objekt ticket tak zrusi podanie
                if (stored.GUID) {
                    ticket.ticketFailed("TicketSubmit_Failed_Err");
                } else {
                    ticket.ticketClear(true);
                    main.unlockApp();
                }
            }
            main.userAction();
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketApproved() # " + e);
            return false;
        }
    },

    // Funkcia ktora preposle betID na nativnu aplikaciu ktora nasledne potvrdi podany tiket
    actionQuickBetTicketPrint: function(betID, amount) {
        try {
            ActionQuickBetTicketPrint(betID, amount);
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "actionQuickBetTicketPrint", "#betID: " + betID + " #amount: " + amount + " ERROR: " + JSON.stringify(e));
            return false;
        }
    },

    // Odosielanie výherných ticketov z quickbet na nativeapp
    // Funkcia ktora preposle betID na nativnu aplikaciu ktora nasledne potvrdi stavenie tiketu
    ticketConfirmQuickBet: function(betID) {
        try {
            if (betID) {
                TicketConfirmQuickbet(betID);
                return true;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "ticketConfirmQuickBet", "#betID: " + betID + " ERROR: " + JSON.stringify(e));
            return false;
        }
    },

    // Funkcia na potvrdenie prijateho tiketu
    ticketSuccess: function(competitionAck) {
        try {
            if (stored.ticket) {
                // Kontrola zapojenia sa do sutaze
                var competitionID = competitionText = null;
                if (competitionAck && stored.CompetitionID) {
                    competitionID = stored.CompetitionID;
                    competitionText = stored.CompetitionText;
                }

                // Vytlaci sa rate orezany na 2 desatine miesta
                stored.ticket.OverallRate = shared.floor2(stored.ticket.OverallRate, 2);

                // Preusporiadanie oddov podla skupin
                if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                    stored.ticket.Odds = stored.ticket.Odds.sort(function (a, b) {
                        return a.Group.localeCompare(b.Group);
                    });
                }

                modal.hideLoading();
                try {
                    ActionTicketSuccess(Math.round(stored.ticket.OverallTotalBet * 100), Math.round(stored.ticket.OverallFee * 100), stored.ticket.SportBoxTicketGUID, JSON.stringify(stored.ticket), competitionID, competitionText);
                    // Uspesna tlac (TicketPrint_Success) sa loguje zo strany nativeApp ako JSON tiketu
                    main.createLog(3, stored.ticket.SubmittedLog, "GUID: " + ticket.anonymGuid(stored.ticket.SportBoxTicketGUID)
                        + " # BET: " + stored.ticket.OverallTotalBet
                        + " # FEE: " + stored.ticket.OverallFee
                        + " # RATE: " + stored.ticket.OverallRate
                        + " # WIN: " + stored.ticket.OverallPotWin
                        + " # WINFISCAL: " + stored.ticket.FiscalOverallPotWin
                        + " # CREATED: " + stored.ticket.PlaceBetDate
                        + " # COMPETITION: " + JSON.stringify(stored.ticket.TicketCompetitions));
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    main.createLog(2, "TicketPrint_Failed", "GUID: " + ticket.anonymGuid(stored.ticket.SportBoxTicketGUID)
                        + " # BET: " + stored.ticket.OverallTotalBet
                        + " # FEE: " + stored.ticket.OverallFee
                        + " # RATE: " + stored.ticket.OverallRate
                        + " # WIN: " + stored.ticket.OverallPotWin
                        + " # WINFISCAL: " + stored.ticket.FiscalOverallPotWin
                        + " # CREATED: " + stored.ticket.PlaceBetDate
                        + " # COMPETITION: " + JSON.stringify(stored.ticket.TicketCompetitions) + " # Errors: " + e);
                }

                if (!stored.ticket.ComboID) {
                    ticket.ticketCheck("reset");
                } else {
                    modal.showErrObj(2, 5, {err1: stored.ticket.Err1, err2: stored.ticket.Err2, errType: "default"});
                    // Ak nieje hrac prihlaseny, zobrazi napovedu ak je tiket prazdny 10 sekund
                    if (!stored.PlayerID) {
                        ticket.depositDialToggle(true);
                        ticket.showHelp();
                    }
                }
                // Ak su moje tikety aktivne tak ich nanovo stiahne inak vymaze chache
                if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                    player.playerTickets.myTicketsFilter(false, true);
                } else {
                    delete cache.MyTickets;
                }

                stored.submitting = false;
                return true;

            } else {
                // Ak nema objekt ticket tak zrusi podanie
                if (stored.GUID) {
                    ticket.ticketFailed("TicketSubmit_Failed_Err");
                } else {
                    ticket.ticketClear(true);
                }
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketSuccess() # " + e);
            return false;
        }
    },

    // Vynuteny reset tiketu z nativeApp
    ticketReset: function(value) {
        try {
            main.createLog(3, "CentralTicketReset_Called", value);
            ticket.ticketClear(true);
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na reset tiketu
    ticketWsReset: function(isEditTicketCancelling, isLogout) {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/reset")
                .done(function (data) {

                    if (data === Object(data)) {
                        // Nastavi defaultny typ tiketu
                        main.createLog(3, "CentralTicketReset_Success");
                        // Odznaci pripadne oznacene oddy v zapasoch dna
                        $("#sportBox .content-table .ui-btn-up-e").removeClass("ui-btn-up-e");
                        // Nastavenie limitov
                        ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                        // Vynutena zmena prepnutia na jednoduchy tiket pretoze JT nieje nastaveny na ticketWS alebo na UI
                        if ((data.TYPE !== ticket.state.ticketWsTypes.JT) || !ticket.state.isTicketWsType(ticket.state.ticketWsTypes.JT)) {
                             ticket.ticketTypeSwitch(ticket.state.ticketWsTypes.JT);
                        }
                        // Aktualizuje freebet
                        if ((profile.Freebet || profile.Bonification) && stored.PlayerID) {
                            ticket.ticketPromoModule.clearFreebetBonification(true);
                            data.TYPE = ticket.state.ticketWsTypes.JT;
                            ticket.ticketPromoModule.ctRenderFreebetBonifications(data);
                        }
                        // Odznaci podavanie za winy
                        ticket.ticketWinCurrencyModule.deactivate();
                        // Skryje deposit kalkulacku a kombinacie
                        ticket.depositDialToggle(true);
                        if (isLogout || (stored.PlayerID && (stored.PlayerID === profile.ManualVerifiedPlayerID))) {
                            ticket.ticket(data, null, true, true);
                            // Vycisti a zablokuje pristup k mojim tiketom
                            player.playerTickets.clearMyTickets(true);
                            // Nastavi view bez playera
                            events.eventsSignalrModule.setSignalR();
                        } else if (stored.PlayerID) {
                            // Opatovne prihlasi hlaca na tiketovu sluzbu
                            ticket.ticketWsSetPlayer(stored.PlayerID);
                        } else if (!stored.PlayerID && isEditTicketCancelling) {
                            ticket.ticket(data, null, true, true);
                        }
                        return true;

                    } else {
                        main.createLog(2, "CentralTicketReset_Failed", "CALL RETRIEVE");
                        ticket.ticketWsRetrieveRepeat(sets.refreshTime);
                        return false;
                    }
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "CentralTicketReset_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                    setTimeout(function () {
                        ticket.ticketWsRetrieveRepeat(sets.refreshTime);
                    }, sets.deltaTimeLive);
                    return false;
                });

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketReset_Failed", "ERROR in: ticket.ticketWsReset() # " + e);
            setTimeout(function () {
                ticket.ticketWsRetrieveRepeat(sets.refreshTime);
            }, sets.deltaTimeLive);
            return false;
        }
    },

    // Funkcia ktora otvori alebo zatvori deposit-kalkulacku
    depositDialToggle: function(keepClose, keepOpen, submitTicketAction) {
        try {
            if (keepClose) {
                if ($("#bonificationList").is(':visible')) {
                    $("#bonificationAvailable").removeClass("list-opened");
                    $("#bonificationList").hide();
                }
                if ($("#freebetList").is(':visible')) {
                    $("#freebetAvailable").removeClass("list-opened");
                    $("#freebetList").hide();
                }
                if ($("#rateChangesList").is(':visible')) {
                    $("#rateChanges").removeClass("list-opened");
                    $("#footer-sidebar .rate-changes-btn .ui-btn-text").text(texts.RateChangeShow);
                    $("#rateChangesList").hide();
                }
                if (stored.combinationList && !submitTicketAction) {
                    ticket.ticketCombiModule.combinationBtnToggle(true);
                    $("#combinationList").hide();
                }
                if (!$("#depositDial").is(":visible")) $("#hideOffer").removeClass();
            }
            if ($("#depositDial").is(":visible") && !keepOpen) {
                // Ak je deposit-kalkulacka otvorena a nie je poziadavka aby ostala otvorena tak ju zatvori
                $("#depositDial").hide();
                $("#footer-sidebar #dialTrigger").removeClass("calc-opened");
                if (!stored.combinationList && !$("#freebetList").is(':visible') && !$("#bonificationList").is(':visible'))
                    $("#hideOffer").removeAttr("class");
                // Prisposobenie panelu kombinacii
                $("#sportBox .content-ticket").removeClass('with-dial');
                if ((!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) || stored.BetLock == "locked" || submitTicketAction)) {
                    if (!ticket.state.getState().isClonedTicket && !stored.combiTicketAllPinned) {
                        if (!ticket.state.getState().isWinCurrencyTicket && !stored.Balance && !stored.FreebetID) {
                            // Stavka za FIAT balance, hrac nema balance a nepodava za freebety
                            modal.showErrObj(1, 5, {err1: texts.TicketErr03, err2: texts.TicketErr04, errType: "TicketErr03"});
                            ticket.calc('clear');
                        } else if (!ticket.state.getState().isWinCurrencyTicket && (stored.Balance < stored.OverallTotalBet)) {
                            // Stavka za FIAT balance, hrac ma mensi balance ako je vklad na tiket
                            modal.showErrObj(1, 5, {err1: texts.TicketErr17, errType: "TicketErr17"});
                            ticket.calc('clear');
                        } else if (ticket.state.getState().isWinCurrencyTicket && (stored.WinCurrencyClientBalance < stored.WinCurrencyTotalBet)) {
                            // Stavenie za winy ale hrac ma mensi pocet winov ako je vklad na tiket
                            modal.showErrObj(1, 5, {err1: texts.TicketWinCurrencyInsufficientErr1, errType: "TicketWinCurrencyInsufficientErr1"});
                            ticket.calc('clear');
                        } else {
                            // Nastav vysku vkladu aj na server (s parametrom ci rovno podat tiket)
                            ticket.ticketCombiModule.ctSetBet(submitTicketAction, true);
                        }
                    } else {
                        ticket.state.setState({isClonedTicket: false});
                        ticket.submitTicket();
                    }
                }
            } else {
                // Ak je deposit-kalkulacka zatvorena alebo je poziadavka aby ostala otvorena
                if (!keepClose || keepOpen) {
                    // Ak nie je poziadavka aby ostala zatvorena alebo je poziadavka aby bola otvorena tak ju otvori
                    $("#depositDial").show();
                    // Prisposobenie panelu kombinacii
                    $("#sportBox .content-ticket").addClass('with-dial');
                    $("#footer-sidebar #dialTrigger").addClass("calc-opened");
                    $("#hideOffer").addClass("hide-offer-active");
                    // Ak otvori kalkulacku a ma zvoleny freebet alebo bonifikaciu tak ich zrusi
                    $("#freebetHeader, #bonificationHeader").hide();
                    if (stored.FreebetID) ticket.ticketPromoModule.removeFreebet();
                    if (stored.BonificationID) ticket.ticketPromoModule.removeBonification();
                    // Ak nema zvolenu ziadnu kombinaciu tak mu ich ponukne
                    ticket.ticketCombiModule.checkCombinations();
                }
                // Ak chcem zaroven vsadit ticket (ctSetBet bol uz nastaveny)
                if (submitTicketAction) {
                    ticket.submitTicket();
                } else if (!ticket.state.getState().isLotteryTicket) {
                    // Ak by ostalo zablokovane tlactiko submitTicket
                    main.unlockSbmButtons(true);
                }
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.unlockSbmButtons(true);
            return false;
        }
    },

    /**
     *
     * Funkcia  1. Zmeni typ tiketu na ticketovej sluzbe JT/SRT (ak je to potrebne)
     *          2. Zmeni zobrazenie tiketu na UI JT/SRT/SRTL/MT
     * 
     * ticketTypeSwitch => ctType => changeTicketView
     *
     * @param {string} ticketType                   Pozadovany typ tiketu
     * @param {string} ticketWSForcedType           Typ tiketu prisiel z ticketovej sluzby - nieje potrebne ziadat zmenu typu tiketu na ticketWS
     */
    ticketTypeSwitch: async function(ticketType, ticketWSForcedType) {
        try {
            // Kontrola poziadavky pre nastavenie tabu
            if (!Object.keys(ticket.state.ticketTabs).includes(ticketType)) {
                return false;
            }
            // Kontrola poziadavky pre zmenu typu tiketu
            if ([ticket.state.ticketWsTypes.JT, ticket.state.ticketWsTypes.SRT].includes(ticketType)) {
                try {
                    if (!ticketWSForcedType) {
                        // Zmeni typ tiketu na ticketovej sluzbe
                        data = await ticket.ctType(ticketType);
                        // OK
                        if (data?.TYPE) {
                            // Ulozi TYPE nastaveny na ticketovej sluzbe pre nasledne prekreslenie ticketu
                            ticketType = data.TYPE;
                        }
                    }
                } catch(e) {
                    // Neuspesna zmena typu tiketu
                    ticket.ticketWsRetrieve(true);
                    main.createLog(2, "CentralTicketSwitchType_Failed", e.toString());
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    return false;
                }
            } else if (profile.IsWinCurrency) {
                ticket.ticketWinCurrencyModule.updateWinCurrencyClientBalance();
            }
            //Zmeni zobrazenie tiketu na UI
            ticket.changeTicketView(ticketType);
            switch (ticketType) {
                case ticket.state.ticketWsTypes.JT:
                    // JEDNODUCHY TIKET
                    communication.topScreen("hideHelpSRT");
                    break;

                case ticket.state.ticketWsTypes.SRT:
                    // SKUPINOVO-ROZPISOVY TIKET
                    if (stored.BetAll) {
                        // Zrusi tlacitko MAX ak je aktivne
                        stored.BetAll = false;
                        $(".bet-all .ui-btn").removeClass("ui-btn-active");
                        document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                    }
                    if (ticket.balance() && (ticket.balance() >= stored.MinDeposit)) {
                        // Player s balancom vacsim ako s min povolenym celkovym vkladom na kombi tiket - Uzamkne vklad
                        ticket.ticketCombiModule.ctRenderLockButton();
                    } else {
                        // Odomkne vklad
                        ticket.ticketCombiModule.ctRenderUnLockButton();
                    }
                    if (ticket.state.getState().isLotteryTicket) {
                        modal.hideLoading();
                    } else {
                        // Napovedu na vrchnej obrazovke zobrazi pre standardny (neloteriovy) SRT tiket
                        communication.topScreen("showHelpSRT");
                    }

                    break;

                case ticket.state.ticketTabs.MT:
                    // MOJE TIKETY
                    ticket.changeTicketView(ticket.state.ticketTabs.MT);

                    communication.topScreen("hideHelpSRT");
                    // Skryje editacny mod
                    ticket.ticketEditModule.prepareTicketForEdit(false);
                    // Skryje deposit kalkulacku a kombinacie
                    ticket.depositDialToggle(true);
                    // Nacita moje tikety
                    service.loadPure("myTickets");
                    break;
                default:
                    return false;
                    break;
            }
            return true;
        } catch (e) {
            main.createLog(2, "ticketTypeSwitch_Failed", e.toString());
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na nastavenie povolenej zmenovosti kurzov pocas podavania tiketu
    allowedRateChange: function(rateChangeType, save) {
        try {
            main.userAction();
            if (rateChangeType) {
                var requestUrl;
                main.lockSbmButtons();
                $("#rateChangesButtons label").each(function(r, rateChInput) {
                    $(rateChInput).removeClass("ui-radio-on");
                });
                $("#rateChangesButtons #acceptRate" + rateChangeType + "Label").addClass("ui-radio-on");
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/setallowedratechange/" + rateChangeType)
                    .done(function (data) {
                        stored.AllowedRateChange = data.AllowedRateChangeDesc.charAt(0) + data.AllowedRateChangeDesc.slice(1).toLowerCase();
                        if (stored.AllowedRateChange === rateChangeType) {
                            main.createLog(3, "CentralTicketAllowedRateChange_Success", " # PlayerID: " + stored.PlayerID + " # AllowedRateChange: " + stored.AllowedRateChange);
                            player.playerSettingsModule.modifyUserSettingsObject("allowedRateChangePlayer", stored.AllowedRateChange, "noModify");
                            if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID)) {
                                player.playerSettingsModule.modifyUserSettingsObject("allowedRateChangePlayer", stored.AllowedRateChange);
                                if (save) {
                                    stored.UserSettings.Original.allowedRateChangePlayer = stored.UserSettings.Modified.allowedRateChangePlayer;
                                    player.playerSettingsModule.setPlayerInfo();
                                }
                            } else {
                                $("#rateChangesButtons").find(".ui-radio-on").removeClass("ui-radio-on");
                                $("#rateChangesButtons").find("#acceptRate" + stored.AllowedRateChange + "Label").addClass("ui-radio-on");
                            }
                        } else {
                            $("#rateChangesButtons").find(".ui-radio-on").removeClass("ui-radio-on");
                            $("#rateChangesButtons").find("#acceptRate" + stored.AllowedRateChange + "Label").addClass("ui-radio-on");
                            main.createLog(2, "CentralTicketAllowedRateChange_Failed", " # PlayerID: " + stored.PlayerID + " # LAST VALUE: " + data.AllowedRateChangeDesc + " # ACTUAL VALUE: " + rateChangeType);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketAllowedRateChange_Failed", " # PlayerID: " + stored.PlayerID + " # AllowedRateChange: " + rateChangeType + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        $("#rateChangesButtons label").each(function(r, rateChInput) {
                            $(rateChInput).removeClass("ui-radio-on");
                        });
                        $("#rateChangesButtons #acceptRate" + stored.AllowedRateChange + "Label").addClass("ui-radio-on");
                    })
                    .always(function () {
                        main.unlockSbmButtons();
                    });
                return true;
            }
            return false;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Vymazanie tiketu
    ticketClear: function(ticketReset, isLogout) {
        try {
            modal.showLoading();
            // Pocas odstranovania tiketu zamkne tiket, tlacitko Submit ticket a Clear ticket
            main.lockSbmButtons();
            if (!ticketReset) {
                $("#ticketClearConfirm").addClass("ui-disabled");
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/clear")
                    .done(function (data) {
                        if (data === Object(data)) {

                            // Uspesne vymazanie tiketu
                            if (data.Errors && !data.Errors.length) {
                                ticket.ticketCheck("clear");
                                if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                                    ticket.ticketTypeSwitch(ticket.state.ticketWsTypes.JT);
                                }
                                list.OddsExpired = [];
                                list.OddsExpiredHidden = [];
                                list.OddsRateChanged = [];
                                modal.hideLoading();
                                return true;

                            } else {
                                var errors = modal.parseErrors(data.Errors);
                                modal.showErrObj(2, 5, {errObj: errors});
                            }

                        } else {
                            // Neuspesne vymazanie tiketu
                            main.createLog(2, "CentralTicketClearTicket_Failed");
                            ticket.ticketCheck("reset");
                            return false;
                        }
                    })

                    // Neuspesne vymazanie tiketu
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketClearTicket_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                        service.loadPure('ticket');
                        // Spristupni tiket, tlacitko Submit ticket a Clear ticket
                        main.unlockSbmButtons();
                        // Zobrazi kombinacie
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) ticket.ticketCombiModule.showCombinationList();
                        return false;
                    })

                    // Zatvorenie okna
                    .always(function () {
                        main.closeDialog();
                        setTimeout(function () {
                            $("#ticketClearConfirm").removeClass("ui-disabled");
                        }, 500);
                    });

            } else {
                ticket.ticketCheck("reset", false, isLogout);
                modal.hideLoading();
                return true;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.unlockSbmButtons();
            $("#ticketClearConfirm").removeClass("ui-disabled");
            modal.hideLoading();
            return false;
        }
    },

    /**
     *
     * Funkcia na zmenu typu tiketu na ticketovej sluzbe JT/SRT
     *
     * @param {string} requiredTicketType        Pozadovany typ tiketu
     * @returns {Promise<object|boolean>}        Resolve ticket data alebo true ak je spravny typ
     */
     async ctType(requiredTicketType) {
        return new Promise((resolve, reject) => {
            try {
                if (ticket.state.isTicketWsType(requiredTicketType)) {
                    resolve(true);
                    return true;
                }
                if (profile.ConsoleLog || profile.ConsoleLog$.Ticket) {
                    console.log("%cctType: " + requiredTicketType, "color: orange; font-size: 16px; font-weight: bold;");
                }
                modal.showLoading();
                main.lockSbmButtons();
                ticket.ticketCombiModule.hideCombinationList(true);
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/type/" + requiredTicketType)
                    .done(function (data) {
                        if (data === Object(data)) {
                            // Uspesna zmena typu tiketu
                            if (data.Errors && !data.Errors.length) {
                                ticket.state.setState({isEditTicket: data.IsEdited});
                                list.Combi = [];
                                list.OddsCombi = [];
                                stored.Rate = stored.BusinessRate = stored.PossibleGrossBet = 0;

                                if (data.TYPE == requiredTicketType) {
                                    ticket.state.setState({type: requiredTicketType});
                                    ticket.ticket(data, null, true, true);
                                    main.createLog(3, "CentralTicketSwitchType_Success", "TYPE: " + requiredTicketType);
                                }

                                // Nastavenie limitov
                                ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);

                                // Vymaze vklad medzi prepnutim JT / SRT
                                ticket.calc("clear");
                            } else if (data.Errors.includes('ERR_VG_TICKET;')) {
                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                modal.showErrObj(2, 5, {errObj: errors});

                                ticket.state.setState({type: ticket.state.ticketWsTypes.JT});
                                ticket.checkSum(data);
                            } else {
                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                modal.showErrObj(2, 5, {errObj: errors});
                            }
                            resolve(data);
                        } else {
                            reject("[TYPE: " + requiredTicketType + "]");
                        }
                    })
                    // Neuspesna zmena typu tiketu
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        reject("[TYPE: " + requiredTicketType + "] # AJAX FAILED: " + JSON.stringify(jqXHR));
                    })
                    .always(function () {
                        main.unlockSbmButtons();
                        modal.hideLoading();
                    });

            } catch (e) {
                reject("[TYPE: " + requiredTicketType + "] # ERROR: " + e.toString());
            }
        })
    },

    // Kontrola podpornosti
    competitorCheck: function(oddID) {
        try {
            // Zistim betType
            var conflictOdd = false;
                if (!$.mobile.activePage.is("#event") && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                    // Jedna sa o inline detail
                    betType = $("#events .event-detail-inline #" + oddID).attr("betType");
                } else {
                    betType = $("#event .chances #" + oddID).closest(".chance").attr("betType");
                }

            // Virtualne hry s betType VICTORIA (PSY & KONE)
            if (offer.sportID == offer.vgID && betType == "VICTORIA") {
                return true;
            }

            // Specialne stavky Victoria Competitor - mozem kombinovat medzi chancetypes ale nesmie byt rovnaky competitorID
            else if (betType == "VICTORIA_COMPETITOR") { // Vsetky ostatne chancetype budu ties VICTORIA_COMPETITOR
                // Zistim cometitorID oznaceneho ODDu
                var competitorID = $("#event .chances #" + oddID).attr("competitorID");
                // Hladam na tikete nejaky odd z aktualneho eventu a nasledne sa pozriem ci nema ROVANKY competitorID
                if (competitorID) {
                    $.each(list.Events, function (i, eventID) {
                        if (offer.eventID == eventID)
                            if (competitorID == $("#event .chances #" + list.Odds[i]).attr("competitorID")) {
                                // Ak najdem odd s rovnakym competitorID ako aktualne zvoleny tak vratim jeho oddID
                                conflictOdd = list.Odds[i];
                                return false;
                            }
                    });
                    // Ak nenajdem konflikt podpornosti tak vratim true
                    if (conflictOdd) {
                        return conflictOdd;
                    } else {
                        return true;
                    }

                } else {
                    // Ak neviem zistit competitorID tak vratim false
                    return false;
                }
            }

            // Players - strelec golu / asistencia - mozem kombinovat len v ramci samotnej chancetype, nie v ramci eventu
            else if (betType == "VICTORIA_PLAYER") {
                // Zistim chanceTypeID oznaceneho ODDu
                var chanceTypeID = $("#event .chances #" + oddID).closest(".chance").attr("ID");
                // Hladam na tikete nejaky odd z aktualneho eventu a nasledne sa pozriem ci nema ROZDIELNY chanceTypeID
                if (chanceTypeID) {
                    $.each(list.Events, function (i, eventID) {
                        if (offer.eventID == eventID)
                            if (chanceTypeID != $("#event .chances #" + list.Odds[i]).closest(".chance").attr("ID")) {
                                // Ak najdem odd z inej chanceType ako aktualne zvoleny tak vratim true
                                conflictOdd = true;
                                return false;
                            }
                    });
                    // Ak nenajdem konflikt podpornosti tak vratim true
                    if (conflictOdd) {
                        return false
                    } else {
                        return true;
                    }

                } else {
                    // Ak neviem zistit chanceTypeID tak vratim false
                    return false;
                }
            }

            // Vsetko ostatne vratane klasickej VICTORIA - nemozem kombinovat v ramci eventu s nicim inym
            else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Vytvorenie tiketu a nasledne nastavenie jazyka, prepne na jednoduchy tiket (#5)
    ticketWsRetrieve: function(keepType, onlySetClient, playerID) {
        try {
            if (stored.CID) {
                main.lockSbmButtons();
                var requestUrl, requestTime = new Date().getTime() + stored.time;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/retrieve/" + offer.lang + "/" + stored.CID)
                    .done(function (data, statusText, jqXHR) {
                        if (data === Object(data)) {

                            // Uspesna inicializacia tiketu
                            main.createLog(3, "CentralTicketCreateTicket_Success", "CID: " + stored.CID);
                            if (profile.ConsoleLog || profile.ConsoleLog$.Ticket) {
                                if (requestTime) jqXHR.requestTimeUTC = new Date(requestTime);
                                console.log("$$$ Ticket - ticketWsRetrieve: "
                                    + " | keepType: " + keepType
                                    + " | onlySetClient: " + onlySetClient
                                    + " | playerID: " + playerID
                                    + " | statusText: " + statusText
                                    + " | status: " + jqXHR.status
                                    + " | requestTime: " + jqXHR.requestTimeUTC
                                );
                            }
                            rfs.ticketCreate = null;
                            ct.ticketRetrieve = 1;

                            if ((data.AllowedRateChangeDesc?.charAt(0) + data.AllowedRateChangeDesc?.slice(1).toLowerCase()) !== (stored.AllowedRateChange || profile.AllowedRateChangeDefault)) {
                                ticket.allowedRateChange(stored.AllowedRateChange || profile.AllowedRateChangeDefault);
                            }

                            // Ak je tiket oznaceny ako v editacii
                            if (data.IsEdited) {
                                ticket.ticketEditModule.editTicketSubscription(data.PlaceBetTicketCode, "ADD", data.SportBoxTicketGUID, data);
                            } else if (data.PlaceBetState || data.Errors[0] == "ALREADY_PLACEBET;") {
                            // Vycistenie tiketu ak ostal v stave schaleny alebo caka na schvalenie
                                // Ak ma GUID tak vystornuje tiket cez nativeApp nasledkom coho resetuje tiket
                                if (!(stored.GUID = data.SportBoxTicketGUID)) stored.GUID = stored.BonusMoney = null;
                                ticket.ticketFailed("TicketSubmit_Failed_Err", "CONNECTION LOST");

                            } else if (keepType) {

                                // Ak sa nema zmenit typ tiketu tak skontroluje jeho zobrazenie voci ticketWS
                                ticket.ticketTypeSwitch(data.TYPE, !ticket.state.isTicketWsType(data.TYPE));

                                // Prerenderuje tiket
                                setTimeout(function () {
                                    ticket.ticketRender(data);
                                }, 100);

                            } else {

                                // Ak sa ma zmenit typ defaultne na jednoduchy tiket
                                if (data.TYPE !== ticket.state.ticketWsTypes.JT && !data?.IsLotteryTicket) {
                                    // Ak nebol nastaveny ako jednoduchy tak ho nastavi
                                    setTimeout(function() {
                                        ticket.ticketTypeSwitch(ticket.state.ticketWsTypes.JT);
                                    }, 500);
                                } else {
                                    // Ak bol nastaveny ako jednoduchy tak ho vyrenderuje
                                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                        ticket.ticketTypeSwitch(ticket.state.ticketWsTypes.JT);
                                    }
                                    setTimeout(function () {
                                        ticket.ticketRender(data);
                                    }, 500);
                                }
                            }

                            // Pokracovanie na dalsiu fazu (#6a)
                            if (ct.initTicketWs) ticket.initTicketWsSuccess(onlySetClient, playerID);

                        } else {
                            // Neuspesna inicializacia tiketu
                            main.createLog(2, "CentralTicketCreateTicket_Failed", "CID: " + stored.CID + " # NO DATA -> TICKET CLEAR | RESET");
                            ticket.ticketClear();
                        }
                    })

                    // Neuspesna inicializacia tiketu
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        if (requestTime) jqXHR.requestTimeUTC = new Date(requestTime);
                        main.createLog(2, "CentralTicketCreateTicket_Failed", "CID: " + stored.CID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        ticket.ticketWsRetrieveRepeat(sets.refreshTime);
                    });

            } else {
                main.createLog(2, "CentralTicketCreateTicket_Failed", "CID: NONE");
                if (main.initWebAppCheck()) ticket.ticketWsRetrieveRepeat(sets.deltaTimeLive);
            }
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketCreateTicket_Failed", "ERROR");
            ticket.ticketWsRetrieveRepeat(sets.refreshTime);
            return false;
        }
    },

    // Funkcia na opakovany pokus vytvorenia tiketu
    ticketWsRetrieveRepeat: function(delay) {
        try {
            if (ct.initTicketWs) {

                // Inicializacia TicketWS pri strarte SB bola neuspesna
                if (ct.initTicketWs < 5) {

                    // Novy pokus o inicializaciu
                    ct.initTicketWs++;
                    rfs.ticketCreate = setTimeout(function () {
                        ticket.ticketWsRetrieve();
                    }, delay);

                } else {

                    // Neuspesne spojenie s ticketWS
                    ticket.initTicketWsFailed();
                }

            } else {

                // Inicializacia TicketWS po podani tiketu bola neuspesna
                if (ct.ticketRetrieve < 5) {
                    ct.ticketRetrieve++;

                    // Opakovanie sa pokusi inicializovat tiket
                    clearTimeout(rfs.ticketCreate);
                    rfs.ticketCreate = setTimeout(function () {
                        ticket.ticketWsRetrieve();
                    }, delay);

                } else {

                    // Neuspesne spojenie s ticketWS
                    ct.ticketRetrieve = 1;
                    ticket.initTicketWsFailed();
                }
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketCreateTicket_Failed", "REPEAT ERROR");
            ticket.ticketWsRetrieveRepeat(delay);
        }
    },

    // Inicializacia tiketu bola uspesna (#6a)
    initTicketWsSuccess: function(onlySetClient, playerID) {
        try {
            ct.initTicketWs = false;

            // Nacitanie klientskych nastaveni Sportboxu (nasledne nastavi jazyk na tikete) (#6b)
            ticket.ticketWsSetClient();

            if (onlySetClient) {
                // Nastavenie PlayerID na tiketovej sluzbe pri ozdraveni ticketWsRetrieve
                if (ticket.ticketWsSetPlayer(playerID)) {
                    // Pripad manualne prihlaseneho hraca
                    // Vycisti a zablokuje pristup k mojim tiketom
                    player.playerTickets.clearMyTickets(true);
                    // Nastavi view bez playera
                    events.eventsSignalrModule.setSignalR();
                }
            } else {
                // Prejde na dalsi fazu spustenia webAplikacie (#7)
                main.startApp(4);
            }
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Inicializacia tiketu zlyhala
    initTicketWsFailed: function() {
        try {

            // ERROR - nepodarila sa synchronizacia pri starte (5 pokusov)
            main.lockApp(-1, "TICKET SYNC ERROR !");
            player.moneyBack();

            // Zaloguje problem
            if (ct.initTicketWs) {
                main.createLog(2, "StartSyncFailed");
            } else {
                main.createLog(2, "SyncServer_Error");
            }

            // Zablokuje sportbox
            setTimeout(function () {
                main.stopHeartBeat();
            }, sets.refreshTime);

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            setTimeout(function () {
                main.startApp(1);
            }, sets.refreshTime);
        }
    },

    // Zmena jazyka na tikete (#6c)
    ticketLang: function() {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/lang/" + offer.lang)
                .done(function () {
                    main.createLog(3, "CentralTicketSetLanguage_Success", "Language: " + offer.lang);
                    return true;
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "CentralTicketSetLanguage_Error", "Language: " + offer.lang + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                    setTimeout(function () {
                        ticket.ticketLang(offer.lang);
                    }, sets.refreshTime);
                    return false;
                });

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketSetLanguage_Error", "Language: " + offer.lang + "  # ERROR: " + e);
            setTimeout(function () {
                ticket.ticketLang(offer.lang);
            }, sets.refreshTime);
            return false;
        }
    },

    // Nacitanie klientskych nastaveni Sportboxu voci tiketovej sluzbe (#6b)
    ticketWsSetClient: function() {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/setclient/" + stored.CID)
                .done(function (data) {
                    if (data === Object(data)) {

                        // Uspesne nacitanie setClient
                        main.createLog(3, "CentralTicketSetClient_Success", "CID: " + stored.CID);

                        // Nastavi manipulacny poplatok (pri nulovom nastavi FeeAmount na 1)
                        if (!data.FeeRate || !(stored.FeeAmount = shared.floor2(1 + data.FeeRate / 100))) stored.FeeAmount = 1;

                        // Nastavi jazyk na tikete (#6c)
                        ticket.ticketLang();

                    } else {

                        // Neuspesna inicializacia tiketu, ozdravenie
                        main.createLog(2, "CentralTicketSetClient_Failed", "CID: " + stored.CID + " # AJAX FAILED: not-object");
                        setTimeout(function () {
                            ct.initTicketWs = true;
                            ticket.ticketWsRetrieve(true, true);
                        }, sets.deltaTimeLive);
                    }
                })

                // Neuspesna inicializacia tiketu, opakuje
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "CentralTicketSetClient_Failed", "CID: " + stored.CID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                    setTimeout(function () {
                        ticket.ticketWsSetClient();
                    }, sets.deltaTimeLive);
                });

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesna inicializacia tiketu, ozdravenie
            main.createLog(2, "CentralTicketSetClient_Failed", "CID: " + stored.CID + " # ERROR");
            ct.initTicketWs = true;
            ticket.ticketWsRetrieve(true, true);
            return false;
        }
    },

    // Funkcia sluzi na zobrazenie informativnej ikonky o moznosti/nemoznosti podat tiket
    updateDepositToggle: function() {
        try {
            if (ticket.balance() && stored.OverallTotalBet && (stored.OverallTotalBet <= ticket.balance()) && (stored.OverallTotalBet >= stored.MinBet)) {
                $("#footer-sidebar #dialTrigger").addClass("bet-ok");
            } else {
                $("#footer-sidebar #dialTrigger").removeClass("bet-ok");
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vrati FIAT balance alebo WinCurrency balance prepocitany do FIAT meny
    balance: function() {
        if (ticket.state.getState().isWinCurrencyTicket) {
            // Return hodnota sa pouziva na prepocty Win balance => FIAT mena
            return Math.trunc(stored.WinCurrencyClientBalance * profile.WinCurrencyConversionRate * 100) / 100;
        }
        return stored.Balance;
    },

    // Funckia na overenie podmienok pred potvrdenim tlacitka PLACE BET
    checkBet: function() {
        try {
            var errContainer = []
            list.Sync = 0;
            var errTicketSubmitObj;
            var isWinCurrencyBet = ticket.state.getState().isWinCurrencyTicket;
            // Zamkne submit tlacitka, pri submit all zatvori dialogove okno
            main.lockSbmButtons(true);

            // Prazdny ucet, ziadne tipy a nejde o freebet
            if (!stored.FreebetID && ticket.balance() == 0 && list.Odds.length == 0) {
                errContainer[0] = isWinCurrencyBet? texts.TicketWinCurrencyInsufficientErr1 : texts.TicketErr03;
                errContainer[1] = texts.TicketErr01;
            }

            // Prazdny ucet/win balance a nejde o freebet ani editaciu tiketu
            else if (!stored.FreebetID && !ticket.state.getState().isEditTicket && ticket.balance() == 0) {
                errContainer[0] = isWinCurrencyBet? texts.TicketWinCurrencyInsufficientErr1 : texts.TicketErr03;
                // Pripadne Nizky celkovy kurz
                if (stored.Rate <= stored.FeeAmount + 0.01) {
                    errContainer[1] = texts.TicketErr12[1] + " " + stored.FeeAmount;
                } else if (!isWinCurrencyBet) {
                    errContainer[1] = texts.TicketErr04;
                }
            }

            // Nedostatocny Balance / Win balance
            else if (!stored.FreebetID && !ticket.state.getState().isEditTicket && ticket.balance() && ticket.balance() < stored.OverallTotalBet) {
                errContainer[0] = isWinCurrencyBet? texts.TicketWinCurrencyInsufficientErr1 : texts.TicketErr17;
            }

            // Prazdny tiket
            else if (list.Odds.length == 0) {
                errContainer[0] = texts.TicketErr01;
                // Pripadne Nizky vklad
                if (stored.OverallTotalBet < stored.MinDeposit) errContainer[1] = texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinDeposit, 1) + " " + profile.Currency;
            }

            // Ak neboli zvolene ziadne kombinacie pri kombinovanom tikete
            else if (ticket.ticketCombiModule.checkCombinations()) {
                errContainer[0] = texts.TicketErr14;
            }

            // Nulovy vklad (vsadit vsetko) - ak nie je prekrocena max cista vyhra pri minimalnom vklade
            else if (stored.OverallTotalBet == 0) {
                if (ticket.calc("all", false)) {
                    if (!parseFloat(stored.Rate)) ticket.ticketCombiModule.showCombinationList();
                    if (!$("#depositDial").is(':visible')) ticket.depositDialToggle();
                    main.unlockSbmButtons(true);
                    errContainer[0] = -1;
                } else {
                    errContainer[0] = -2;
                }
            }

            // Nizky celkovy kurz (nejedna sa o editaciu tiketu)
            else if ((stored.Rate <= stored.FeeAmount) && !ticket.state.getState().isEditTicket) {
                errContainer[0] = texts.TicketErr12[1] + " " + stored.FeeAmount;
                if (list.Odds.length && (stored.Rate == 0)) {
                    // Ozdravny mechanizmus v pripade ze ma oddy na tikete, nulovy celkovy kurz a snazi sa podat tiket
                    ticket.ticketWsRetrieve();
                }
            }

            // Zamknute odds na tikete
            else if (list.OddsExpired.length) {
                errTicketSubmitObj = modal.parseErrors(["ERR_ODDEXP:" + list.OddsExpired.join(";ERR_ODDEXP:")]);
            }

            // Kontrola MaxBet (MaxBet != 0)
            else if (!ticket.state.getState().isEditTicket && !ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && stored.PossibleGrossBet && stored.PossibleGrossBet < stored.OverallTotalBet) {
                // Ak ma nastaveny Freebet alebo Bonifikaciu tak ich zrusi
                if (stored.FreebetID) ticket.ticketPromoModule.removeFreebet();
                if (stored.BonificationID) ticket.ticketPromoModule.removeBonification();
                // Prekroceny naberovy limit na stavku
                errContainer[0] = texts.TicketErr11;
                errContainer[1] = texts.Tc_ERR_MAXBET + " " + shared.floor2(stored.PossibleGrossBet, 1) + " " + profile.Currency;
            }

            // Nizky vklad pre jednoduchy tiket
            else if (!ticket.state.getState().isEditTicket && !ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && stored.OverallTotalBet < stored.MinDeposit) {
                errContainer[0] = texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinDeposit, 1) + " " + profile.Currency;
                errContainer[1] = texts.TicketErr04;
            }

            // Nizky vklad pre kombinovany tiket alebo jednotlivu kombinaciu
            else if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                // Nizky vklad na jednu kombinaciu
                var minSlips = 0;
                $.each(list.OddsCombi, function (i, odd) {
                    // Na kombinacie su dovolene nulove vklady s podmienkou ze su vklady minimalne vo vyske profile.MinDepPerSlip
                    if (odd.Bet && odd.Bet < profile.MinDepPerSlip) {
                        errContainer[0] = texts.TicketErr13 + " " + shared.floor2(profile.MinDepPerSlip, 1) + " " + profile.Currency;
                        return false;
                    } else if (odd.Bet) {
                        ++minSlips;
                    }
                });
                // Zaroven plati ze celkovy vklad na tiket (vsetky kombinacie) je minimalne vo vyske stored.MinDeposit
                if (stored.OverallTotalBet < stored.MinDeposit) errContainer[0] = texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinDeposit, 1) + " " + profile.Currency;
                if (errContainer[0] && ticket.balance() < stored.MinDeposit) {
                    errContainer[1] = isWinCurrencyBet? "" : texts.TicketErr04;
                }
                // Ak su splnene vysky vkladov tak sa skontroluje minimalny pocet kombinacii, ktory musi byt aspon profile.MinSlips
                if (!ticket.state.getState().isLotteryTicket && !errContainer[0] && minSlips < profile.MinSlips) errContainer[0] = texts.Tc_ERR_MORECOMBI;
            }

            // Overenie ci hrac splna podmienky pre placebet
            var restriction;
            if (restriction = ticket.playerNotAllowedForBetting()) {
                if (restriction === "PLAYER_INTERNAL_RVO_ERROR") {
                    // Nastala chyba pri volani RVO sluzby
                    modal.showErrObj(2, 5, {err1: texts.InternalRvoError, errType: "InternalRvoError"});
                } else {
                    modal.openVLCModal(restriction);
                }
                main.createLog(2, "TicketSubmit_NotAllowed_" + restriction, " # PlayerID: " + stored.PlayerID + " # IsVerified: " + stored.IsVerified + " # IsInternalRvoError: " + stored.IsInternalRvoError + " # IsGamingClub: " + profile.IsGamingClub);
                main.unlockSbmButtons(true);
            }
            // Overenie ci hrac nepodava tiket nad limit ak nema vyplnene zdroje prijmov. V takom pripade zobrazi okno vyberu zdrojov prijmu
            else if (profile.IsSourceOfIncome && stored.OverallTotalBet >= profile.SourcesOfIncomeOverallTotalBetLimit && stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID && !player.incomeSourcesModule.playerIncomeSources?.length) {
                // Zobrazit okno vyberu zdrojov prijmu
                player.incomeSourcesModule.showIncomeSourcesModal(true);
                main.unlockSbmButtons(true);
            }

            // Skontroluje ci sa nenasla ani jedna chyba a nebola prekrocena max cista vyhra
            else if (errContainer[0] || errTicketSubmitObj) {
                if (errContainer[0] != -1) {
                    setTimeout(function () {
                        main.unlockSbmButtons(true);
                    }, 500);
                    if (errTicketSubmitObj) modal.showErrObj(1, 10000, {errObj: errTicketSubmitObj});
                    if (errContainer[0] != -2) modal.showErrObj(2, 3, {err1: errContainer[0], err2: errContainer[1], errType: "default"});
                }
            }

            // Ak je vklad kombinovaneho tiketu pri zamknuti vyzsi ako je vyskla balancu tak resetne piny na kombinacie
            else if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && stored.OverallTotalBet > ticket.balance()) {
                ticket.ticketCombiModule.ctBetLock();
                main.unlockSbmButtons(true);
            }

            // Pokusi sa odoslat tiket
            else if (main.initWebAppCheck()) {
                ticket.depositDialToggle(true, false, true);
            }

            // Nepodarilo sa odoslat tiket
            else {
                main.unlockSbmButtons(true);
            }
            main.closeDialog();

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.unlockSbmButtons(true);
            return false;
        }
    },

    // Funkcia na spracovanie tipov na tikete
    ticketDeltaCheck: function(data) {
        try {
            // Ak je tiket neodoslany s tym, ze sa niektore z tipov zmenili alebo je niektory tip vymazany
            if (list.Odds.length) {
                // Tipy, ktore maju byt aktualizovane
                if (data.Odds) {
                    for (i = 0; i < data.Odds.length; i++) {
                        ticket.ticketOddModule.addRemoveOddFromList(data.Odds[i]);
                        ticket.ticketOddModule.oddChangedTicket(data.Odds[i]);
                    }
                    modal.errorResolver();
                } else if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                    ticket.ticketPromoModule.freebetBonificationShowButtons(true);
                }

                // Aktualizacia tabulky kombinacii - logicky dojde k zmene OverallRate a zavola sa ticket.checkSum()
                if (data.OddsCombi) for (i = 0; i < data.OddsCombi.length; i++) {
                    ticket.ticketCombiModule.combiTableDeltaUpdate(data.OddsCombi[i]);
                    $.each(list.OddsCombi, function (index, groupCombi) {
                        if (groupCombi.ID == data.OddsCombi[i].ID) groupCombi.Rate = data.OddsCombi[i].Rate;
                    });
                }

                // Prepocitanie celkovej moznej vyhry
                if (((data.OverallRateRaw = parseFloat(data.OverallRateRaw)) || data.OverallRateRaw == 0) && (data.OverallRateRaw != stored.Rate)
                    ||
                    ((data.BusinessRate = parseFloat(data.BusinessRate))) && (data.BusinessRate != stored.BusinessRate)
                ) {
                    stored.Rate = data.OverallRateRaw;
                    ticket.checkSum(data, true);
                }

                // Nastavi ticket deltu
                // Neplati ze sa spoliehame na signalR - https://codium-fsm.atlassian.net/browse/OF-97
                ticket.setTicketRefresh();
            }
            // Zmena kurzov v plachte
            if (data && data.Odds) {
                data.Odds.forEach(function(odd) {
                    events.eventsSignalrModule.oddChanged(odd.OddID, odd.Rate, (odd.IsActive? "active" : "suspended"));
                });
            }
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na aktualizaciu oddov na tikete
    ticketDelta: function(isRecursive) {
        try {
            if (isRecursive && delta.ticketDeltaRequest?.state() === "pending") {
                // Vytvoreny ticketDelta request je v stave pending
                ++delta.ticketDeltaPendingCount;
                if (delta.ticketDeltaPendingCount >= delta.ticketDeltaMaximumPendingCount) {
                    // Zrusi request a vyvola novy request na ticket deltu
                    delta.ticketDeltaRequest?.abort();
                    events.eventsSignalrModule.ticketDeltaClear(false);
                    ticket.ticketDelta();
                }
            } else if ((new Date().getTime() - delta.ticketDeltaTimeStamp > delta.ticketDeltaPause) && delta.ticketDeltaRequest?.state() !== "pending") {
                // Nebol vytvoreny request ticketDelta alebo ubehla 1s od kedy bol vytvoreny
                events.eventsSignalrModule.ticketDeltaClear(true);
                delta.ticketDeltaTimeStamp = new Date().getTime();
                delta.ticketDeltaRequest = $.getJSON(delta.requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/delta")
                .done(function (data) {
                    if (profile.ConsoleLog || profile.ConsoleLog$.TicketDelta) {
                        console.log("$   TicketDelta interval [s] " + sets.ticketDelta / 1000);
                        console.log(data);
                    }
                    console.log("Ticket delta called at: " + new Date().toISOString());
                    // Vymaze vsetky znacky z tiketu a tabulky
                    $("#ticketList").find("#crsOriginal, #flg").removeAttr("class");
                    $("#combiList #flg").removeAttr("class");
                    if (data === Object(data)) ticket.ticketDeltaCheck(data);
                })
                return true;
            } else if (!delta.ticketDeltaTimeout) {
                delta.ticketDeltaTimeout = setTimeout(() => {
                    // Pocka 500ms, znova zavola ticket.ticketDelta()
                    ticket.ticketDelta(true);
                }, 500);
            }
        } catch (e) {
            events.eventsSignalrModule.ticketDeltaClear(true);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na udrzanie tiketu v redise
    ticketRecovery: function(run) {
        try {
            clearInterval(rfs.ticketRecovery);
            rfs.ticketRecovery = null;

            // Spustenie ticketRecovery
            if (run) {
                rfs.ticketRecovery = setInterval(function () {
                    ticket.ticketWsRetrieve();
                }, sets.ticketRecovery);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora zabezpeci zobrazenie napovedy
    showHelp: function(show) {
        try {
            clearTimeout(ct.showHelp);
            if (show || !ct.showHelp) {
                show = 0;
            } else {
                show = sets.showHelp;
            }
            ct.showHelp = setTimeout(function () {
                if (list.Odds.length == 0) {
                    $("#ticketHelp").show();
                    ticket.markingHelp();
                    ticket.ticketPromoModule.clearFreebetBonification(true);
                }
                ct.showHelp = true;
            }, show);

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora cyklicky zvyraznuje polozky v napovede
    markingHelp: function() {
        try {
            var m = 1;
            $("#ticketHelp .help-marked").removeClass("help-marked");
            $("#ticketHelp .help-step").eq(0).addClass("help-marked");
            ticket.stopMarkingHelp();
            ct.markingHelp = setInterval(function () {
                $("#ticketHelp .help-marked").removeClass("help-marked");
                $("#ticketHelp .help-step").eq(m).addClass("help-marked");
                m++;
                if (m == $("#ticketHelp .help-step").size()) m = 0;
            }, sets.markingHelp);

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na stopnutie markingHelp
    stopMarkingHelp: function() {
        clearInterval(ct.markingHelp);
        ct.markingHelp = null;
    },

    // Volanie na NativeApp pri vyhernom tikete (cash: false - previest na balance, cash: true - vytlacit kreditny listok)
    ticketConfirm: function(cash) {
        if (stored.OriginalInputGUID) {
            try {
                main.lockApp();
                if (TicketConfirm(stored.OriginalInputGUID, cash)) {
                    main.closeDialog();
                    main.unlockApp();
                    // Opatovne nacita moje tikety
                    return true;
                }
                main.unlockApp();
                return false;
            } catch(e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                main.unlockApp();
                return false;
            }
        }
    },

    // Volanie na nativeApp pri vyhernom tikete - Prevod na online balance
    ticketConfirmToOnline() {
        if (stored.OriginalInputGUID && stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
            try {
                main.lockApp();
                if (TicketConfirmToOnline(stored.OriginalInputGUID)) {
                    main.closeDialog();
                    main.unlockApp();
                    // V pripade aktivneho online balance nativeApp zavola setBalanceWithPlayerInfo, nasledne sa zobrazi infoModal o uspesnosti prevodu vyhry
                    setTimeout(function() {
                        modal.showInfoModal(8, 0, '', texts.CreditTransferOnlineSuccess, texts.CreditTransferOnlineSuccessDesc, false, false, {buttonCloseText: texts.ConfirmButtonOK, buttonCloseAction: "modal.hideInfoModal();"});
                    }, 1000);
                    // Opatovne nacita moje tikety
                    return true;
                }
                main.unlockApp();

            } catch(e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                main.unlockApp();
                return false;
            }
        } else {
            modal.showErr(3, 0, texts.LogInRequired, texts.LogInRequiredDesc);
        }
    },

    // Kontrola ci prebieha prijem alebo schvalovanie tiketu
    isTicketInProgress: function() {
        if (stored.submitting || rfs.approve) {
            return true;
        } else {
            return false;
        }
    },

    // funkcia na obnovenie ulozeneho tiketu
    retrieveSavedTicket: function(ticketCodePin) {
        main.lockApp();
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/SBID_" + stored.SBID + "/restore/" + ticketCodePin)
                .done(function (data) {
                    if (data === Object(data) && data.TYPE) {

                        ticket.state.setState({liveBetDelayMs: data.LiveBetDelayMs, isEditTicket: data.IsEdited});
                        ticket.ticketTypeSwitch(data.TYPE);
                        ticket.ticketRender(data);

                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            ticket.ticketCombiModule.ctRenderCombinations(data);
                            $("#depositDial #displayDial").find("#lotterySingleStakeValue").removeClass("selected-input");
                            stored.inputElement = $("#depositDial #displayDial").addClass("selected-input");
                        }

                        // Ak je balance mensi ako prednastavena hodnota, tak zrusi vysku vkladu
                        if (ticket.balance() < data.OverallTotalBet) ticket.calc("clear");

                        ticket.checkSum(data);

                        // Zobraz detail tiketu
                        data.isStoredTicket = true;
                        ticketDetail.ticketStatusRender(data);
                        main.dialogOpen("ticketStatus");

                        if (stored.PlayerID && stored.PlayerID !== data.PlayerID) {
                            // Hrac je prihlaseny na: SB native, SB FE. NIEJE prihlaseny na ticketWS preto nastavi playerID na ticketovej sluzbe
                            // Po prihlaseni sa zobrazi tlacitko Stavit tiket, pokial hrac nema obmedzenie
                            ticket.ticketWsSetPlayer(stored.PlayerID, !ticket.playerNotAllowedForBetting());
                        } else {
                            if (!ticket.playerNotAllowedForBetting()) {
                                $("#ticketStatus .status-buttons .submit-ticket").removeClass("ui-disabled").show();
                            }
                        }
                        return true;
                    } else {
                        ticket.ticketCheck("reset");
                        return false;
                    }

                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    return false;
                })
                .always(function () {
                    main.unlockApp();
                });
        } catch (e) {
            main.unlockApp();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na vyrenderovanie tiketu
    ticketRender: function(data) {
        try {
            if (data) {
                if (data.Odds && data.Odds.length) {
                    // Ak ticket refresh ma nastavenu hodnotu TotalBet tak ju nastavi
                    if (data.OverallTotalBet = parseFloat(data.OverallTotalBet)) {
                        stored.OverallTotalBet = data.OverallTotalBet;
                    }
                    // Vyrenderuje tiket a naplni novy odds a events list
                    ticket.ticket(data, null, true, true);
                    main.unlockSbmButtons();
                    return true;

                } else {
                    ticket.ticketCheck("clear");
                    return false;
                }
            } else {
                ticket.ticketWsRetrieve(true);
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    /**
     *
     * Funkcia na nastavenie PlayerID na tiketovej sluzbe
     *
     * @param playerID             playerID pre nastavenie na tiketovu sluzbu
     * @param showPlaceBetButton   Priznak ci zobrazit tlacidlo Stavit tiket v detaile tiketu
     * @returns {(boolean)}        false - vytvoreny request na tiketovu sluzbu alebo bolo zavolane ticket Retreive, true - neprihlasuje sa na tiketovu sluzbu (manualne overeny hrac)
     */
    // Nastavenie PlayerID na tiketovej sluzbe
    ticketWsSetPlayer: function(playerID, showPlaceBetButton) {
        try {
            if (playerID === profile.ManualVerifiedPlayerID) {
                // Manualne overeny hrac sa neprihlasuje na tiketovu sluzbu, SB funguje v rezime anonymneho tipovania
                ticket.ticketPromoModule.ctRenderFreebetBonifications({PlayerID: playerID});
                return true;
            }
            if (!playerID) playerID = 0; // Odhlasenie
            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/setplayer/" + playerID)
                .done(function (data) {
                    if (data === Object(data)) {

                        // Nastavenie playerID
                        main.createLog(3, "CentralTicketSetPlayer_Success", "PlayerID: " + playerID + " #data.PlayerID: " + data.PlayerID);
                        ticket.ticket(data, null, true, true);

                        // Vymaze moje tikety, Nastavi default skupinu mojich tiketov
                        player.playerTickets.clearMyTickets(true);
                        stored.myTicketsActiveGroup = profile.MyTickets[0];

                        if (data.PlayerID) {
                            if (data.PlayerID === playerID) {
                                // Nastavenie playerID prebehlo uspesne
                                if (!list.Odds.length) {
                                    // Pokial nema oddy na tikete skryje pomocnik pre tiket a prepne na zobrazenie mojich tiketov
                                    clearTimeout(ct.showHelp);
                                    $("#ticketHelp").hide();
                                    ticket.stopMarkingHelp();
                                    // Pripravi moje tikety
                                    ticket.ticketTypeSwitch(ticket.state.ticketTabs.MT);
                                } else {
                                    ticket.checkSum(data);
                                }

                                // Nastavi signalr, ak nieje pripojeny tak ho inicializuje
                                events.eventsSignalrModule.checkSignalR(events.eventsSignalrModule.setSignalR, events.eventsSignalrModule.initSignalR);
        
                                // Spristupni tab moje tikety
                                $("#ticketTop #myTickets").removeClass("ui-disabled");

                                // Aktualizuje stav editacie tiketu
                                ticket.state.setState({isEditTicket: data.IsEdited});

                                // Ulozi freebety (potrebne pre zobrazenie modalneho okna freebetu)
                                if (profile.Freebet) {
                                    // Ulozi freebety a prekresli fb a bonifikacie
                                    stored.Freebets = data.Freebets;
                                    ticket.ticketPromoModule.ctRenderFreebetBonifications(data);
                                }

                                if (profile.IsWinCurrency && typeof data.WinCurrencyClientBalance === "number") {
                                    // Situacia po prihlaseni hraca na ticket sluzbu && maju sa zobrazovat winy
                                    player.setWinCurrencyClientBalance(data.WinCurrencyClientBalance, false);
                                }

                                // Ziskanie zdrojov prijmu hraca
                                if (profile.IsSourceOfIncome) {
                                    player.incomeSourcesModule.obtainPlayerIncomeSources();
                                }
        
                                // Zobrazi tlacidlo stavit tiket
                                if (showPlaceBetButton) {
                                    $("#ticketStatus .status-buttons .submit-ticket").removeClass("ui-disabled").show();
                                }
        
                                // Vyziada status hracskych bonusov
                                if (profile.Bonuses) {
                                    player.playerBonusModule.getBonusesStatus();
                                }
                            } else {
                                // Nastavenie playerID neprebehlo uspesne
                                player.playerTickets.clearMyTickets(true);
                            }

                        } else {
                            // Uzivatel je uspesne odhlaseny, vycisti a zablokuje pristup k mojim tiketom
                            player.playerTickets.clearMyTickets(true);
                            $("#bonusesButton .bonus-button-dot").hide();

                            if ((data.AllowedRateChangeDesc?.charAt(0) + data.AllowedRateChangeDesc?.slice(1).toLowerCase()) !== profile.AllowedRateChangeDefault) {
                                // Nastavi default hodnotu akceptacie zmeny kurzu pri staveni
                                ticket.allowedRateChange(profile.AllowedRateChangeDefault);
                            }

                            // Nastavi view bez playera
                            events.eventsSignalrModule.setSignalR();

                            if (!list.Odds.length) {
                                // Prazdny tiket po odhlaseni prepne do default - JT
                                ticket.ticketTypeSwitch(ticket.state.ticketWsTypes.JT);
                                // Zobrazi napovedu ak je tiket prazdny 10 sekund
                                ticket.showHelp();
                            }
                        }
                    } else {
                        // Neuspesne nastavenie playerID, ozdravenie
                        player.playerTickets.clearMyTickets(true);
                        main.createLog(2, "CentralTicketSetPlayer_Failed", "PlayerID: " + playerID + " # AJAX FAILED: not-object");
                        setTimeout(function () {
                            ct.initTicketWs = true;
                            ticket.ticketWsRetrieve(true, true, playerID);
                        }, sets.deltaTimeLive);
                    }

                    if (data.IsEdited && stored.PlayerID !== data.PlayerID) {
                        // Aktualne nastaveny hrac nezodpoveda stavu tiketu zrusi editaciu
                        ticket.ticketWsReset(true);
                    }
                })

                // Neuspesne nastavenie playerID, opakuje
                .fail(function (jqXHR) {
                    player.playerTickets.clearMyTickets(true);
                    jqXHR.requestUrl = requestUrl;
                    main.createLog(2, "CentralTicketSetPlayer_Failed", "PlayerID: " + playerID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                    setTimeout(function () {
                        ticket.ticketWsSetPlayer(playerID);
                    }, sets.deltaTimeLive);
                });
                return false;
        } catch (e) {
            player.playerTickets.clearMyTickets(true);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesne nastavenie playerID, ozdravenie
            main.createLog(2, "CentralTicketSetPlayer_Failed", "PlayerID: " + playerID + " # ERROR");
            ct.initTicketWs = true;
            ticket.ticketWsRetrieve(true, true, playerID);
            return false;
        }
    },

    // Funkcia na obsluhu zadavania vkladu
    calc: function(value, setBet) {
        try {
            // Ak nieje vybrany ziadny vstup
            if (!stored.inputElement && value === "clear") {
                $("#depositDial #displayDial").find("#lotterySingleStakeValue").removeClass("selected-input");
                stored.inputElement = $("#depositDial #displayDial").addClass("selected-input");
            }
            if (!stored.inputElement && value != "all") {
                clearTimeout(rfs.glow);
                $("#combiList .combi-list__cell--bet, #combiButtons .combi-buttons__item__input, #depositDial #displayDial").removeClass('glow').addClass('glow');
                rfs.glow = setTimeout(function () {
                    $("#combiList .combi-list__cell--bet, #combiButtons .combi-buttons__item__input, #depositDial #displayDial").removeClass('glow');
                    rfs.glow = null;
                }, 1000);
                return true;
            } else if (value == "all") {
                $("#depositDial #displayDial").find("#lotterySingleStakeValue").removeClass("selected-input");
                stored.inputElement = $("#depositDial #displayDial").addClass("selected-input");
            }

            // Automaticke zavolanie ctSetBet po 2 sekundach
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && stored.inputElement) {
                // Nastavi animaciu zadavania vkladu
                if (!($(stored.inputElement).hasClass("pulse"))) $(stored.inputElement).addClass("pulse");
                if (!stored.BetAll || !setBet) {
                    clearTimeout(rfs.ctSetBet);
                    stored.CombiTimerActive = true;
                    rfs.ctSetBet = setTimeout(function () {
                        stored.CombiTimerActive = false;
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            if (value != "all" && stored.BetAll && $(stored.inputElement).is('#displayDial')) {
                                stored.BetAll = false;
                                $(".bet-all .ui-btn").removeClass("ui-btn-active");
                                document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                            }
                            ticket.ticketCombiModule.combiInputSwitch();
                        }
                    }, sets.ctSetBet);
                }
            }

            // Ak sa jedna o specialne polia pre zadavanie kombinovaneho tiketu
            if (typeof value === 'undefined') value = "clear";
            if ($(stored.inputElement).hasClass('stake-bet')) {
                ticket.ticketCombiModule.calcCombi(value);
            } else if ($(stored.inputElement).hasClass('combi-list__bet-value') && value != "all") {
                // Vklad na KOMBINACIE
                ticket.ticketCombiModule.calcCombi(value);
            } else if ($(stored.inputElement).hasClass('combi-buttons__item__input') && value != "all") {
                // Vklad na ROZPIS
                ticket.ticketCombiModule.calcCombi(value);
            } else {

                // Celkovy vklad pre jednoduchy tiket aj pre kombinovany tiket
                switch (value) {

                    // Vklad na desatine miesta
                    case "comma":
                        if (stored.Decimal) {
                            stored.Decimal = false;
                            $("#calcComma .ui-btn").removeClass("ui-btn-active");
                        } else {
                            stored.Centesimal = false;
                            stored.Decimal = true;
                            $("#calcComma .ui-btn").addClass("ui-btn-active");
                        }
                        break;

                    // Zmazat vklad
                    case "clear":
                        stored.BetAll = false;
                        stored.Decimal = false;
                        if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            $("#footer-sidebar #dialTrigger").removeClass("bet-ok");
                            if (stored.OverallTotalBet) {
                                stored.OverallTotalBet = stored.OverallFee = 0;
                                if (stored.overallPotWin) {
                                    // Nenulovy stored.overallPotWin a teda je nastaveny kladny OverallTotalBet na ticketWS
                                    ticket.ticketCombiModule.ctSetBet(false, true, true, false);
                                } else {
                                    // Staci zavolat checkSum
                                    ticket.checkSum();
                                }
                            }
                        } else if (stored.inputElement) {
                            $("#footer-sidebar #dialTrigger").removeClass("bet-ok");
                            if (stored.OverallTotalBet == 0) {
                                ticket.ticketCombiModule.ctSetBet(false, true, true, 1);
                            } else {
                                stored.OverallTotalBet = stored.OverallFee = 0;
                                ticket.ticketCombiModule.ctSetBet(false, true, true, 0);
                            }
                        }
                        $(".bet-all .ui-btn, #calcComma .ui-btn").removeClass("ui-btn-active");
                        document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                        main.unlockSbmButtons(true);
                        break;

                    // Zadat vklad
                    default:
                        // Ucet bez penazi
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && (stored.BetLock != "unlock" || (ticket.state.getState().isLotteryTicket && value === "all")) && ticket.balance() == 0) {
                            stored.OverallTotalBet = 0;
                            if (ticket.state.getState().isWinCurrencyTicket) {
                                modal.showErrObj(2, 3, {err1: texts.TicketWinCurrencyInsufficientErr1, errType: "TicketWinCurrencyInsufficientErr1"});
                            } else {
                                modal.showErrObj(2, 3, {err1: texts.TicketErr03, err2: texts.TicketErr04, errType: "TicketErr03"});
                            }
                        } else {
                            var errContainer = [];

                            // Neprazdny ucet
                            switch (value) {

                                // Vsadit vsetko
                                case "all":
                                    if (stored.FreebetID) {
                                        // Ak ma aktivovany freebet tak ho najprv zrusi
                                        ticket.ticketPromoModule.removeFreebet();
                                    } else {
                                        // Toggle prepinaca MAX
                                        if (stored.BetAll && !setBet) {
                                            stored.BetAll = false;
                                            $(".bet-all .ui-btn").removeClass("ui-btn-active");
                                            document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                                        } else {
                                            stored.BetAll = true;
                                            $(".bet-all .ui-btn").addClass("ui-btn-active");
                                            document.querySelector(".deposit-dial__button--all").classList.add("deposit-dial__button--active");
                                        }
                                        stored.Decimal = false;
                                        $("#calcComma").find(".ui-btn").removeClass("ui-btn-active");

                                        var selectedBalance = ticket.balance();
                                        if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                            // Nastavenie MAX balance/winov
                                            if (stored.PossibleGrossBet && selectedBalance && (stored.PossibleGrossBet < selectedBalance)) {
                                                stored.OverallTotalBet = stored.PossibleGrossBet;
                                            } else if (!selectedBalance && stored.PossibleGrossBet) {
                                                stored.OverallTotalBet = stored.PossibleGrossBet;
                                            } else {
                                                stored.OverallTotalBet = selectedBalance;
                                            }
                                        } else {

                                            if (list.OddsCombi.length) {
                                                stored.OverallTotalBet = selectedBalance;
                                                if (stored.PossibleGrossBet && stored.PossibleGrossBet < stored.OverallTotalBet) {
                                                    stored.OverallTotalBet = stored.PossibleGrossBet;
                                                    if (ticket.ticketCombiModule.checkCombinations()) {
                                                        errContainer[0] = texts.TicketErr14;
                                                    } else {
                                                        errContainer[0] = texts.Tc_ERR_MAXBET + " " + shared.floor2(stored.PossibleGrossBet, 1) + " " + profile.Currency;
                                                    }
                                                } else if (stored.OverallTotalBet < profile.MinDepPerSlip) {
                                                    errContainer[0] = texts.TicketErr13 + " " + shared.floor2(profile.MinDepPerSlip, 1) + " " + profile.Currency;
                                                }

                                            } else {
                                                ticket.calc("clear");
                                                if (!parseFloat(stored.Rate)) ticket.ticketCombiModule.showCombinationList();
                                                if (!$("#depositDial").is(':visible')) ticket.depositDialToggle();
                                                $(stored.inputElement).removeClass("pulse");
                                                $('#combinationList').addClass('glow');
                                                setTimeout(function () {
                                                    $('#combinationList').removeAttr('class');
                                                }, 3000);
                                                errContainer[0] = texts.TicketErr14;
                                            }
                                            ticket.ticketCombiModule.ctUpdateCombiBets();
                                        }
                                    }
                                    break;

                                // Zmena vysky vkladu
                                default:
                                    // Pripocitanie za desatinou ciarkou
                                    if (stored.Decimal) {
                                        // Stotina
                                        if (stored.Centesimal) {
                                            if (stored.inputElementJustSelected) {
                                                stored.OverallTotalBet = shared.floor2(value / 100);
                                                stored.inputElementJustSelected = false;
                                            } else {
                                                stored.OverallTotalBet = shared.floor2(stored.OverallTotalBet + value / 100);
                                                stored.Centesimal = false;
                                            }
                                        } else {
                                            // Desatine miesto
                                            if (stored.inputElementJustSelected) {
                                                stored.OverallTotalBet = shared.floor2(value / 100);
                                                stored.inputElementJustSelected = false;
                                            } else {
                                                stored.OverallTotalBet = shared.floor2(parseInt(stored.OverallTotalBet) + value / 10);
                                                stored.Centesimal = true;
                                            }
                                        }
                                    } else {
                                        // Pripocitavanie pred desatinou ciarkou
                                        if (stored.inputElementJustSelected) {
                                            stored.OverallTotalBet = shared.floor2(parseInt(value));
                                            stored.inputElementJustSelected = false;
                                        } else {
                                            stored.OverallTotalBet = shared.floor2(parseInt(stored.OverallTotalBet) * 9 + stored.OverallTotalBet + value);
                                        }
                                    }
                                    // Prepocet kombinacii
                                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) ticket.ticketCombiModule.ctUpdateCombiBets();
                                    break;
                            }

                            // Zobrazi Error hlasku
                            modal.showErrObj(2, 3, {err1: errContainer[0], errType: "default"});

                            // Kontrolny prepocet, ak je nastevy setBet tak sync s ticket WS
                            if (ticket.checkSum()) {
                                if (setBet) ticket.ticketCombiModule.ctSetBet(sets.autoSubmit, true);
                                return true;
                            }
                        }
                }
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vrati lokalizovany tip v nastavenom formate
    getLocalizedTip: function(tip, team1, team2, isLottery, customFormat) {
        if (isLottery) {
            if (tip?.includes(',')) {
                if (customFormat) {
                    // Loteria tip1,tip2,tip3 -> tip1&nbsp- tip2&nbsp- tip3
                    return tip.replace(/\,/g, '\u00A0- ');
                }
                // Loteria tip1,tip2,tip3 -> tip1 - tip2 - tip3
                return tip.replace(/\,/g, ' - ');
            }
            return tip;
        }
        // Ostatne pripady
        if (profile.TipsFormat == "team" || profile.TipsFormat == "teamX") {
            localizedTip1 = team1;
            localizedTip2 = team2;
        }
        if (tip) {
            if (!profile.TipsFormat) {
                return tip;
            } else {
                switch (tip) {
                    case "1":
                        return localizedTip1;
                        break;
                    case "X":
                        return texts["EventTip-X"];
                        break;
                    case "2":
                        return localizedTip2;
                        break;
                    case "1X":
                        if (profile.TipsFormat === "teamX") {
                            return "1X";
                        } else {
                            return localizedTip1 + " " + texts["EventTip-OR"] + " " + texts["EventTip-X"];
                        }
                        break;
                    case "X2":
                        if (profile.TipsFormat === "teamX") {
                            return "X2";
                        } else {
                            return texts["EventTip-X"] + " " + texts["EventTip-OR"] + " " + localizedTip2;
                        }
                        break;
                    case "12":
                        if (profile.TipsFormat === "teamX") {
                            return "12";
                        } else {
                            return localizedTip1 + " " + texts["EventTip-OR"] + " " + localizedTip2;
                        }
                        break;
                    default:
                        return tip;
                        break;
                }
            }
        }
    },

    // Funkcia na zaklade guid tiketu vrati zanonymizovane guid vo formate XXXXXXXXXXXXABCD
    anonymGuid: function(guid) {
        var encryptedGuid = "";
        if (guid && guid.length) {
            encryptedGuid = "X".repeat(guid.length - 4) + guid.slice(-4);
            return encryptedGuid;
        }
        return encryptedGuid;
    },

    // Oznacenie udalosti na tikete
    checkEvent: function(id) {
        try {
            if (stored.actionsHandling.scrolledByTapAndHold) {
                stored.actionsHandling.scrolledByTapAndHold = false;
                return false;
            }
            $("#createGroup .ui-btn-text").html(texts.CombiOptionsCreateGroup);
            $("#ticket .group").removeClass("active-group");
            $("#ticket .group").addClass("inactive-group");

            var element = "#ticketList #" + id,
                checkBtn = $(element).find(".touchable-event"),
                groupID = $(element).attr("name"),
                group = "#group" + groupID;

            // Oznacenie oddu
            if (!checkBtn.hasClass("event-checked")) {
                checkBtn.addClass("event-checked");
                $("#ticketList li#" + id).addClass("checked");
            } else {
                checkBtn.removeClass("event-checked");
                $("#ticketList li#" + id).removeClass("checked");
            }

            var activeItems = $(group).find("li.checked");
            if (activeItems.length) {
                // Ak je v skupine iba jeden odd
                if ($(group).find("li").length == 1) {
                    // Ak je oznaceny element v skupine tutoviek
                    if ($(element).parent().is("#group1")) {
                        $("#removeGroup .ui-btn-text").html(texts.CombiOptionsRemoveGroup);
                        $("#removeGroup").removeClass("ui-disabled");
                    } else {
                        $("#removeGroup .ui-btn-text").html(texts.CombiOptionsRemoveGroup);
                    }
                } else {
                    // Ak je oznaceny element v skupine tutoviek
                    if ($(element).parent().is("#group1")) {
                        $("#removeGroup .ui-btn-text").html(texts.CombiOptionsRemoveGroup);
                        $("#removeGroup").removeClass("ui-disabled");
                    } else {
                        $("#removeGroup .ui-btn-text").html(texts.CombiOptionsRemoveGroup);
                        if ($("#ticketList li[name='" + groupID + "']").length > 1 && activeItems.length === 1 && $("#ticketList li.checked").length === 1) {
                            // Ak je oznaceny odd ktory je uz v skupine a nieje oznaceny iny odd
                            $("#createGroup .ui-btn-text").html(texts.CombiOptionsDeleteOddFromGroup);
                        }
                    }
                    $("#createGroup").removeClass("ui-disabled");
                    $("#removeGroup").removeClass("ui-disabled");
                    $(group).removeClass("inactive-group");
                    $(group).addClass("active-group");
                }
            } else {
                $(group).removeClass("active-group");
                $(group).addClass("inactive-group");
                $("#removeGroup").addClass("ui-disabled");
            }

            if ($("#ticketList .event-checked").length) {
                $("#markTopMatch").removeClass("ui-disabled");
                $("#createGroup").removeClass("ui-disabled");
            } else {
                $("#markTopMatch").addClass("ui-disabled");
                $("#createGroup").addClass("ui-disabled");
            }

            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na stopnutie approve tiketu
    stopTicketApprove: function() {
        try {
            clearInterval(rfs.approve);
            rfs.approve = null;
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na overenie ODDov na tikete
    listCheck: function(oddID, eventID, action, retrieve) {
        try {
            // Zistenie pozicie oddu / eventu v liste
            var i = -1;
            if (oddID) {
                i = list.Odds.indexOf(parseInt(oddID));
                if (!eventID && (eventID = list.Events[i])) {
                    var returnEventID = true;
                }

            } else if (eventID) {
                i = list.Events.indexOf(String(eventID));
                oddID = list.Odds[i];
            }

            if (i != -1) {
                // Odd alebo event sa v liste sa nasiel a ma byt vymazany (ak prave neprebieha podanie tiketu)
                if (!stored.submitting && (action == "remove" || action == "update")) {
                    list.Odds.splice(i, 1);
                    list.Events.splice(i, 1);

                    // Ak je tiket prazdny tak zastavi refresh a za 10 sekund zobrazi napovedu
                    if (!list.Odds.length) {
                        ticket.ticketCheck("clear", retrieve);

                    } else {
                        if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            $("#ticketList #" + oddID).remove();
                        } else {
                            $("#ticketList #" + oddID).parent(".group").remove();
                        }
                        if (action == "remove") {
                            // Najde a odstrani oznaceny odd z eventu
                            $("#events #M" + eventID + " .ui-btn-up-e").removeClass("ui-btn-up-e");

                            // Ak je otvoreny event tak odstrani odd aj v ramci neho
                            if (offer.eventID) $("#event .chances #" + oddID).removeClass("ui-btn-up-e");

                            // Vypise pocet oddov na tikete
                            if (list.Count) list.Count--;
                            $(".ticket-header__item--tips .ticket-header__value").text(list.Count);

                            // Resetuje tiket refresh
                            // Neplati ze sa spoliehame na signalR - https://codium-fsm.atlassian.net/browse/OF-97
                            ticket.setTicketRefresh();
                        }
                    }
                }

                // Odd alebo event sa v liste nasiel
                if (action) {
                    return true;
                } else if (!returnEventID) {
                    return oddID;
                } else {
                    return eventID;
                }

            } else {
                // Odd alebo event sa v liste nenasiel
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na spracovanie MaxBetReason hlasky
    parseMaxBetReason: function(maxBetReason) {
        try {
            if (maxBetReason && (maxBetReason = maxBetReason.split(" @"))) {
                if (!maxBetReason[1] || !(maxBetReason[1] = modal.parseErrorsEvent(maxBetReason[1]))) {
                    return texts["Tc_MBR_" + maxBetReason[0]];
                } else {
                    return "<ul><li>" + texts["Tc_MBR_" + maxBetReason[0]] + ":</li></ul>" + maxBetReason[1];
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zistenie splnenia podmienok pre betovanie
    playerNotAllowedForBetting: function() {
        try {
            if (profile.IsLoginRequired) {
                if (profile.IsGamingClub) {
                    // Pravidla ktore platia pre SB v herni
                    if (stored.PlayerID) {
                        // Kontrola ci je hrac prihlaseny (plati aj pre manualne verifikovaneho hraca a "zelenu kartu" stored.PlayerID == profile.ManualVerifiedPlayerID == -10)
                        if (!stored.IsVerified) {
                            return "PLAYER_NOT_VERIFIED";  // Okno nema zmysel ked IsBiometricLoginOnly = true
                        } else if (stored.IsGamblingProhibited) {
                            if (stored.IsInternalRvoError) {
                                return "PLAYER_INTERNAL_RVO_ERROR";
                            }
                            return "PLAYER_GAMBLING_PROHIBITED_IN_GAMING_CLUB";
                        }
                    } else if (profile.IsBiometricLoginOnly) {
                        return "PLAYER_BET_REQUIRES_BIOMETRIC_LOGIN";
                    } else if (!profile.VerifyCardActivation) { // Pre hernu kde je potrebne prihlasenie (IsLoginRequired && IsGamingClub) sa hrac kontroluje (ako v ne-herni) zaroven sa kontroluju podmienky VerifyCardActivation a IsRvoManualUnblockingAllowed
                        return "NO_PLAYER";
                    } else if (profile.IsRvoManualUnblockingAllowed) {
                        return "OPTIONS-3";
                    } else {
                        return "OPTIONS-2";
                    }
                } else {
                    // Pravidla pre SB ktory nieje v herni
                    if (stored.PlayerID) {
                        // Kontrola ci je hrac prihlaseny (plati aj pre manualne verifikovaneho hraca a "zelenu kartu" stored.PlayerID == profile.ManualVerifiedPlayerID == -10)
                        if (!stored.IsVerified) {
                            return "PLAYER_NOT_VERIFIED";
                        } else if (stored.IsGamblingProhibited) {
                            if (stored.IsInternalRvoError) {
                                return "PLAYER_INTERNAL_RVO_ERROR";
                            }
                            return "PLAYER_GAMBLING_PROHIBITED";
                        }
                    } else if (profile.IsBiometricLoginOnly) {
                        return "PLAYER_BET_REQUIRES_BIOMETRIC_LOGIN";
                    } else if (!profile.VerifyCardActivation) {
                        return "NO_PLAYER";
                    } else if (profile.IsRvoManualUnblockingAllowed) {
                        return "OPTIONS-3";
                    } else {
                        return "OPTIONS-2";
                    }
                }
            }
            // Situacia riesena L Olejar, P Varhanik:
            // IsLoginRequired = false
            // IsBiometricLoginOnly = true
            // ahoj, neviem, ci v sa to v praxi vyskytne, ale mozne to je
            // - to by bolo nieco ako je v sucasnosti herna, ze sa tam mozes, ale nemusis prihlasit pre podanie tiketu,
            // akurat ze tu by si sa mohol prihlasit iba biometricky (alebo podas tiket bez prihlasenia)
            // => povolime podat tiket aj neprihlasenemu
            return false;
        } catch (e) {
            main.closeDialog();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    /**
     *
     * Funkcia na nastavenie minimalnych a maximalnych moznych vkladov na tiket vratane manipulacneho poplatku
     *
     * @param minBet            Minimlana vyska vkladu na tiket vratane manipulacneho poplatku (MP)
     * @param maxBet            Maximalna vyska stavky na jednu kombinaciu bez MP (pouziva sa len v SRT ako priemerna hodnota)
     * @param maxBetReason      Dovod obmedzenia na maxBet
     * @param possibleGrossBet  Celkova maximalna mozna vyska vkladu na tiket vratane MP (pri SRT za vsetky kombinacie)
     * @param overallTotalBet   Celkovy vklad
     */
    setMinMaxBet: function(minBet, maxBet, maxBetReason, possibleGrossBet, overallTotalBet) {
        try {
            if (typeof minBet != "undefined" && typeof maxBet != "undefined") {
                var errContainer = [], multiplier = 1;

                if (maxBetReason) {
                    stored.PossibleGrossBetReason = maxBetReason;
                } else {
                    stored.PossibleGrossBetReason = null;
                }

                // Osetrenie aby nesiel possibleGrossBet do minusu
                if (possibleGrossBet < 0) possibleGrossBet = 0;

                // Ak bol deposit pod limit tak sa nastavi na mozne minimum (error ticket.checkSum() logicky nevrati)
                if (minBet >= stored.MinDeposit && stored.MinBet != (minBet = shared.floor2(minBet))) {
                    stored.MinBet = minBet;

                    if (stored.OverallTotalBet != 0 && stored.OverallTotalBet < stored.MinBet && minBet < possibleGrossBet) {

                        if (ticket.balance() >= stored.MinBet) {
                            stored.OverallTotalBet = stored.MinBet;
                        } else {
                            stored.OverallTotalBet = 0;
                        }
                        errContainer[0] = texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinBet, 1) + " " + profile.Currency;
                        if (possibleGrossBet) ticket.ticketCombiModule.ctSetBet(false, true);
                    }
                }

                // Ak bol deposit nad limit tak sa nastavi na mozne maximum (error ticket.checkSum() logicky nevrati)
                if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                    possibleGrossBet = Math.ceil(possibleGrossBet * 100) / 100;
                } else {
                    possibleGrossBet = shared.floor2(possibleGrossBet);
                }
                if (possibleGrossBet && list.Odds.length && (stored.PossibleGrossBet != possibleGrossBet || stored.BetAll)) {
                    stored.PossibleGrossBet = possibleGrossBet;

                    if (stored.PossibleGrossBet < stored.OverallTotalBet || (stored.BetAll && ticket.balance() > stored.OverallTotalBet)) {

                        possibleGrossBet = ticket.balance();
                        if (stored.PossibleGrossBet < ticket.balance()) {
                            possibleGrossBet = stored.PossibleGrossBet;
                            if (stored.OverallTotalBet != possibleGrossBet) possibleGrossBet = stored.OverallTotalBet;
                        }
                        if (possibleGrossBet >= stored.MinBet) {
                            stored.OverallTotalBet = possibleGrossBet;
                            // Kontrola vysky vklady na pocet kombinacii
                            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && (shared.floor2(maxBet) < profile.MinDepPerSlip)) {
                                stored.OverallTotalBet = 0;
                                ticket.ticketCombiModule.ctUpdateCombiBets(true);
                            }
                        } else {
                            stored.OverallTotalBet = 0;
                            ticket.ticketCombiModule.ctUpdateCombiBets(true);
                        }

                        if (ticket.ticketCombiModule.checkCombinations()) {
                            errContainer[0] = texts.TicketErr14;
                        } else {
                            if (maxBetReason) errContainer[1] = ticket.parseMaxBetReason(maxBetReason);
                        }
                    }
                }

                return errContainer;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia overi max cistu vyhru a vypise summary
    checkSum: function(data, isFromTicketDelta) {
        try {
    
            // Delta, aj full ticket data
            // Len pre editovanie tiketu
            if (data) {
                stored.BusinessRate = parseFloat(data.BusinessRate);
                if (typeof data.OverallTotalBet !== "undefined") {
                    stored.OverallTotalBet = overalTotalBet = data.OverallTotalBet;
                }
                if (typeof data.IsEdited !== "undefined") {
                    stored.IsEdited = data.IsEdited;
                    ticket.ticketEditModule.prepareTicketForEdit(stored.IsEdited, data.PlaceBetTicketCode);
                } 
                if (typeof data.WinCurrencyTotalBet !== "undefined") {
                    stored.WinCurrencyTotalBet = data.WinCurrencyTotalBet;
                }
            } else {
                stored.WinCurrencyTotalBet = Math.ceil(stored.OverallTotalBet / profile.WinCurrencyConversionRate * 100) / 100;
            }
    
            if (stored.OverallTotalBet || stored.FreebetID || stored.BonificationID) {
                var totalBetChanged, overalTotalBet = overallBet = combinationFee = 0, errContainer = [];
    
                if (!stored.FreebetID && !stored.BonificationID && !stored.IsEdited) {
                    // Nastavi overalTotalBet
                    overalTotalBet = stored.OverallTotalBet;
    
                    // Prekrocena max vyska vkladu - dorovnanie s uctom
                    if ((stored.BetLock != "unlock" && overalTotalBet > ticket.balance()) ||
                        (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && stored.PossibleGrossBet && stored.PossibleGrossBet < stored.OverallTotalBet)) {
                        var maxBet = false;
                        totalBetChanged = true;
    
                        if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            // Vypocet maxima JT
                            // Prekroceny maxBet
                            if (stored.PossibleGrossBet && stored.PossibleGrossBet < stored.OverallTotalBet) {
                                stored.OverallTotalBet = stored.PossibleGrossBet;
                                maxBet = true;
                            }
    
                        } else {
                            // Vypocet maxima SRT
                            if (list.OddsCombi.length) {
                                stored.OverallTotalBet = ticket.balance();
    
                                // Prekroceny maxBet
                                if (stored.PossibleGrossBet && stored.PossibleGrossBet < stored.OverallTotalBet) {
                                    stored.OverallTotalBet = stored.PossibleGrossBet;
                                    maxBet = true;
                                }
                                ticket.ticketCombiModule.ctUpdateCombiBets();
                            } else {
                                ticket.calc("clear", true);
                            }
                        }
    
                        // Zobrazenie error hlasky
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && ticket.balance() == 0) {
                            // stored.OverallTotalBet = 0;
                            modal.showErrObj(1, 5, {err1: texts.TicketErr03, err2: texts.TicketErr04, errType: "TicketErr03"});
                        } else {
                            // Ak sa jedna o JT alebo je nenulovy Balance
                            if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                totalBetChanged = false;
                            }
                            stored.BetAll = true;
                            $(".bet-all .ui-btn").addClass("ui-btn-active");
                            document.querySelector(".deposit-dial__button--all").classList.add("deposit-dial__button--active");
                            if (!isFromTicketDelta) {
                                errContainer[0] = texts.TicketErr05;
                                if (!ticket.state.getState().isWinCurrencyTicket) {
                                    errContainer[1] = texts.TicketErr06;
                                }
                            }
                            if (maxBet) {
                                if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                    stored.BetAll = true;
                                    $(".bet-all .ui-btn").addClass("ui-btn-active");
                                    document.querySelector(".deposit-dial__button--all").classList.add("deposit-dial__button--active");
                                    overalTotalBet = stored.OverallTotalBet;
                                }
                                    errContainer[0] = texts.Tc_ERR_MAXBET + " " + shared.floor2(stored.PossibleGrossBet, 1) + " " + profile.Currency;
                                errContainer[1] = ticket.parseMaxBetReason(stored.PossibleGrossBetReason);
                            } else if (stored.OverallTotalBet < stored.MinBet) {
                                if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                    errContainer[0] = texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinBet, 1) + " " + profile.Currency;
                                } else if (list.OddsCombi.length) {
                                    errContainer[0] = texts.TicketErr13 + " " + shared.floor2(profile.MinDepPerSlip, 1) + " " + profile.Currency;
                                }
                                if (errContainer[0] && ticket.balance() < stored.MinDeposit) {
                                    errContainer[1] = texts.TicketErr04;
                                } else {
                                    errContainer[1] = null;
                                }
                            }
                        }
    
                        // Ak doslo ku zmene OverallTotalBet v case kedy su uz data na ticketWS tak jej posle novu hodnotu
                        if (totalBetChanged && data && data.OverallTotalBet) ticket.ticketCombiModule.ctSetBet(false, true);
    
                    } else {
                        // Kontrola nastavenej hodnoty OverallTotalBet na ticketWS - ak nebola na tikete uznana
                        if (data && (data.OverallTotalBet = parseFloat(data.OverallTotalBet)) && data.OverallTotalBet != overalTotalBet) {
                            if (data.Errors.length) {
                                stored.OverallTotalBet = overalTotalBet = data.OverallTotalBet;
                            } else {
                                ticket.ticketCombiModule.ctSetBet(false, true);
                            }
                        } else if (data && data.MaxBet == 0) {
                            // Osetreny stav ked nepadne do podmienky (ked data.OverallTotalBet == 0 != overalTotalBet)
                            stored.OverallTotalBet = overalTotalBet = parseFloat(data.OverallTotalBet);
                            // Pripad nastavenia bet-ka bez kombinacii pride v Errors: ["ERR_MORECOMBI"]
                            if (!data.Errors.length) {
                                errContainer[0] = texts["Tc_MBR_Ticket.MaxWinningAmount"];
                            }
                        }
                    }
                    ticket.updateDepositToggle();
    
                } else {
                    // Nastavenie hodnoty OvellTotalBet z ticketWS
                    if (data && (data.OverallTotalBet = parseFloat(data.OverallTotalBet))) stored.OverallTotalBet = data.OverallTotalBet;
                }
    
                // Ak ma data z ticketWS tak ich len preberie, inak si ich prepocita
                if (!totalBetChanged && data && (data.OverallFee = parseFloat(data.OverallFee))) {
                    stored.OverallFee = shared.floor2(data.OverallFee);
                    // Priemerne Fee na kombinaciu
                    combinationFee = shared.floor2(data.Fee);
                } else {
                    // Prepocet manipulacneho poplatku
                    stored.OverallFee = shared.floor2(stored.OverallTotalBet - shared.floor2(stored.OverallTotalBet / stored.FeeAmount));
                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                        // Priemerne Fee na kombinaciu
                        combinationFee = stored.OverallFee / list.OddsCombi.length;
                    }
                }
    
                // Ak ma data z ticketWS tak ich len preberie, inak si ich prepocita
                if (!totalBetChanged && data && (data.OverallBet = parseFloat(data.OverallBet))) {
                    overallBet = data.OverallBet;
                } else {
    
                    // Ak je vyska manipulacneho poplatku rovna vyske vkladu tak nastavi vklad na nula
                    if (stored.OverallTotalBet && (overallBet = shared.floor2(overalTotalBet - stored.OverallFee)) == 0) {
                        stored.OverallTotalBet = stored.OverallFee = 0;
                        $("#footer-sidebar #dialTrigger").removeClass("bet-ok");
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && !list.OddsCombi.length) {
                            errContainer[0] = texts.TicketErr14;
                        } else {
                            errContainer[0] = texts.TicketErr12[0];
                            errContainer[1] = texts.TicketErr12[1] + " " + stored.FeeAmount;
                        }
    
                    } else if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && profile.MaxWin && stored.Rate > 0 && profile.MaxWin < shared.floor2((stored.OverallTotalBet - stored.OverallFee) * stored.Rate - stored.OverallTotalBet)) {
                        // Spocita vysku manipulacneho poplatku (musi byt vacsi ako 0)
                        overallBet = shared.floor2(profile.MaxWin / (stored.Rate - 1));
    
                        stored.OverallTotalBet = (Math.ceil((overallBet * stored.FeeAmount) * 100) / 100);
                        stored.OverallFee = shared.floor2(stored.OverallTotalBet - overallBet);
    
                        if (stored.OverallTotalBet >= stored.MinDeposit && stored.OverallFee > 0) {
                            errContainer[0] = texts.TicketErr07, profile.MaxWin + " " + profile.Currency;
    
                        } else {
                            // Ak nie je mozne dodrzat podmienky na miminalnu stavku tak sa vklad vymaze
                            stored.OverallTotalBet = stored.OverallFee = overallBet = 0;
                            $("#footer-sidebar #dialTrigger").removeClass("bet-ok");
                            errContainer[0] = texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinDeposit, 1) + " " + profile.Currency, texts.TicketErr07;
                        }
                    } else if (data && ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && profile.MaxWin && (profile.MaxWin < (data.OverallPotWin - data.OverallTotalBet))) {
                        // Ak nie je mozne dodrzat podmienky na miminalnu stavku tak sa vklad vymaze
                        // TODO:
                        // stored.OverallTotalBet = stored.OverallFee = overallBet = 0;
                        $("#footer-sidebar #dialTrigger").removeClass("bet-ok");
                        // errContainer[0] = texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinDeposit, 1) + " " + profile.Currency, texts.TicketErr07;
                        errContainer[0] = texts['Tc_MBR_Ticket.MaxWinningAmount']
                        ticket.ticketCombiModule.ctRenderCombinations(null, false);
                    }
                }
                modal.showErrObj(2, 5, {err1: errContainer[0], err2: errContainer[1], errType: "default"});
    
            }


            if (!totalBetChanged) {
                if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                    // Jednoduchy tiket
                    $("#footer-sidebar").find("span.deposit, span.deposit-main").text(shared.floor2(stored.OverallTotalBet, 1)).attr("currency", profile.Currency);;
                    $("#footer-sidebar .multiplier").text(`${stored.WinCurrencyTotalBet.toLocaleString(profile.LocaleString)} ${profile.WinCurrencySymbol}`);
                } else {
                    // Kombinovany tiket
                    $("#footer-sidebar span.overall-bet").text(shared.floor2(stored.OverallTotalBet, 1) + " " + profile.Currency);
                    $("#footer-sidebar .multiplier").text(
                    `${ticket.state.getState().isWinCurrencyTicket 
                        ? stored.WinCurrencyTotalBet.toLocaleString(profile.LocaleString) + " " + profile.WinCurrencySymbol + "  "
                        : ""} (${list.OddsCombi.length} ${texts.CombiPanelCombinationsShortcut})`
                    );
                    $("#footer-sidebar span.deposit-main").text(shared.floor2(stored.OverallTotalBet, 1));
                    if (profile.Currency) {
                        $("#footer-sidebar span.deposit-main").attr("currency", profile.Currency);
                    }
                    // Ak je odomknuty tiket tak aktualizuje tlacitko na zaokruhlenie vkladu
                    if (stored.BetLock == "unlock") {
                        if (stored.OverallTotalBet) {
                            var roundTotalBet = Math.ceil(stored.OverallTotalBet);
                            if (stored.OverallTotalBet != roundTotalBet) {
                                $("#depositDial #betRound #betRoundValue").text(Math.ceil(stored.OverallTotalBet) + " " + profile.Currency);
                                $("#depositDial #betRound").show();
                            } else {
                                $("#depositDial #betRound").hide();
                            }
                        } else {
                            $("#depositDial #betRound, #depositDial .bet-all").hide();
                            $("#depositDial #betRound #betRoundValue").text("");
                        }
                    }
                }
                if (profile.Currency && (shared.floor2(stored.OverallTotalBet, 1).toString().length + profile.Currency.length) >= 11) {
                    $("#footer-sidebar span.deposit-main").addClass('text-small');
                } else {
                    $("#footer-sidebar span.deposit-main").removeClass('text-small');
                }
    
                // Rate pri vypise zaokruhli na dve desatine cisla smerom nadol
                if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                    // Kurz SRT 
                    if (stored.BusinessRate) {
                        // Zobrazim BusinessRate (kurz zobrazovany pri rozpisovom tikete) ak je nenulovy
                        $("#footer-sidebar .deposit-display #rate").text(shared.formatNumber(shared.floor2(stored.BusinessRate, 2), true)).show();
                    } else {
                        // Ak je nulovy BusinessRate schovam zobrazenie hodnoty kurzu
                        $("#footer-sidebar .deposit-display #rate").hide();
                    }
                } else {
                    // Kurz JT
                    if (stored.Rate) {
                        $("#footer-sidebar .deposit-display #rate").text(shared.formatNumber(shared.floor2(stored.Rate, 2), true)).show();
                    } else {
                        stored.Rate = 0;
                        $("#footer-sidebar .deposit-display #rate").hide();
                    }
                }

                if (stored.OverallTotalBet) {

                    // Manipulacny poplatok
                    if (profile.DisplayFee && stored.FeeAmount > 1) {
                        $("#footer-sidebar .deposit-display #fee").text(shared.floor2(stored.OverallFee, 1)).attr("currency", profile.Currency);
                    }
                    // Ak ma data z ticketWS tak ich len preberie, inak si ich prepocita
                    if (!totalBetChanged && data && data.FiscalOverallPotWin) {
                        if (profile.BoosterBonus && (data.BoosterBonusValue = parseFloat(data.BoosterBonusValue))) {
                            $("#footer-sidebar .deposit-display #bonus").text(shared.floor2(parseFloat(data.BoosterBonusValue), 1)).removeClass("ui-faded");
                            $("#footer-sidebar .deposit-display #bonusWrapper").removeClass("ui-hidden ui-faded");
                        } else if (profile.BoosterBonus && profile.BoosterBonusName === "XXL" && (data.BoosterBonusValueTeaser = parseFloat(data.BoosterBonusValueTeaser))) {
                            $("#footer-sidebar .deposit-display #bonus").text(shared.floor2(parseFloat(data.BoosterBonusValueTeaser), 1)).addClass("ui-faded");
                            $("#footer-sidebar .deposit-display #bonusWrapper").removeClass("ui-hidden").addClass("ui-faded");
                        } else {
                            $("#footer-sidebar .deposit-display #bonus").empty().removeAttr("currency");
                            $("#footer-sidebar .deposit-display #bonusWrapper").addClass("ui-hidden");
                        }
                        $("#footer-sidebar .deposit-display #summary").text(shared.floor2(parseFloat(data.FiscalOverallPotWin), 1));

                    } else {
    
                        // Zmaze a skryje Bonus pretoze ho nevie prepocitat
                        if (profile.BoosterBonus) {
                            $("#footer-sidebar .deposit-display #bonus").empty().removeAttr("currency");
                            $("#footer-sidebar .deposit-display #bonusWrapper").addClass("ui-hidden");
                        }

                        // Prepocet celkovej vyhry
                        if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            // JEDNODUCHY TIKET
                            // Potrebny pocet winov zobrazujem aj v pripade ked nemam kurz
                            $("#displayDial #lotterySingleBet .multiplier").text(`${stored.WinCurrencyTotalBet.toLocaleString(profile.LocaleString)} ${profile.WinCurrencySymbol}`);
                            // Mozna vyhra je zaokruhlena na dve desatine cisla smerom nadol, ale na vypocet pouzije presny celkovy kurz (plny rozvoj)
                            if (stored.Rate) {
                                $("#footer-sidebar .deposit-display #summary").text(shared.floor2(overallBet * stored.Rate, 1)).attr("currency", profile.Currency);
                            } else {
                                $("#footer-sidebar .deposit-display").find("#bonus, #summary").empty().removeAttr("currency");
                            }
    
                        } else {
                            // KOMBINOVANY TIKET
                            var ctTotalWin = 0;
                            if (list.OddsCombi) $.each(list.OddsCombi, function (i, combi) {
                                ctTotalWin += combi.PotWin;
                            });
                            $("#footer-sidebar .deposit-display #summary").text(shared.floor2(ctTotalWin, 1)).attr("currency", profile.Currency);;
                        }
                    }
                    if (profile.Currency && ($("#footer-sidebar .deposit-display #summary").text().length + profile.Currency.length + 1) >= 13) {
                        $("#footer-sidebar .deposit-display #summary").addClass("text-small");
                    } else {
                        $("#footer-sidebar .deposit-display #summary").removeClass("text-small");
                    }
    
                    return true;
    
                } else {
                    $("#footer-sidebar .deposit-display").find("#fee, #bonus, #summary").empty().removeAttr("currency");
                    $("#footer-sidebar .deposit-display #bonusWrapper").addClass("ui-hidden");
                    return false;
                }
            }
    
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia riadenie refresh tiketu
    setTicketRefresh: function() {
        try {
            // Resetne interval refresh tiketu
            ticket.stopTicketRfs();
    
            // Ak je na tikete aspon jeden odd
            if (list.Odds.length) {
                // Najskor nastavi prematch delta time ako default
                sets.ticketDelta = sets.deltaTimePrematch;
                if (odds.find(function(odd) {return odd.LiveBet === true})) {
                    // Na tikete je live odd - nastavi live odd interval
                    sets.ticketDelta = sets.deltaTimeLive;
                } else if (typeof today !== "undefined") {
                    for (var o = 0; o < odds.length; o++) {
                        // Prechadza oddy na tikete
                        var eventDate = odds[o].DATE.split('.');
                        eventDate.arrayMove(0, 1);
                        var minutesUntilEvent = new Date(eventDate.join('-')) - today;
                        if (minutesUntilEvent < sets.closeToLiveEnd) {
                            // Tiket obsahuje odd ktory sa z pohladu ticket delta intervalu povazuje za live
                            sets.ticketDelta = sets.deltaTimeLive;
                            break;
                        } else if (minutesUntilEvent.timeInRange(sets.closeToLiveStart, sets.closeToLiveEnd)) {
                            // Tiket spada do closeToLive delta intervalu
                            sets.ticketDelta = sets.deltaTimeCloseToLive;
                        }
                    }
                }
                // Spusti refresh
                rfs.ticket = setInterval("ticket.ticketDelta()", sets.ticketDelta);
            }
            return true;
    
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.stopTicketRfs();
            return false;
        }
    },

    // Funkcia na stopnutie refreshu tiketu
    stopTicketRfs: function() {
        clearInterval(rfs.ticket);
        rfs.ticket = sets.ticketDelta = null;
    }
};
